($ => {

	let utils;
	let rowData = {};

	const lriGreen = '#54834D';
	const lriGreenLight = '#57A140';
	const lriGreenDark = '#255047';
	const lriGreenMuted = '#8FB88A';
	const green = lriGreen;
	const gray = '#CBCCD9';
	const blue = lriGreenLight;
	const red = '#E74C3C';
	const LRI_PIE_CHART_COLORS = [
		'#54834D', '#57A140', '#255047', '#3d6838', '#8FB88A',
		'#6fa868', '#a8c9a3', '#4DB6AC', '#80CBC4', '#B2DFDB',
		'#FB8C00', '#F57C00', '#FFB300', '#FDD835', '#FFF176',
		'#6D4C41', '#8D6E63', '#A1887F', '#BCAAA4', '#D7CCC8',
		'#607D8B', '#78909C', '#90A4AE', '#B0BEC5', '#CFD8DC'
	];
	const dateFormat = "MMMM Do, YYYY";
	let isIncidentReportRunning = false;
	let shiftDetailsPopup;
	const options = {
		responsive: true,
		legend: {
			position: 'bottom',
			labels: {
				boxWidth: 16,
				fontSize: 16,
				fontColor: '#263251',
				fontFamily: 'Lato',
			}
		},
	};

	function statsLocations() {
		const ctx = document.getElementById('statsLocations');
		if (ctx) {
			const {
				statCompleted,
				statInactive,
				statNotCompleted,
				nameCompleted,
				nameInactive,
				nameNotCompleted,
			} = ctx.dataset;
			const config = {
				type: 'pie',
				data: {
					datasets: [{
						data: [
							Number(statCompleted),
							Number(statInactive),
							Number(statNotCompleted),
						],
						backgroundColor: [
							green,
							gray,
							'#EA4D15',
						],
					}],
					labels: [
						`${nameCompleted} (${Number(statCompleted)})`,
						`${nameInactive} (${Number(statInactive)})`,
						`${nameNotCompleted} (${Number(statNotCompleted)})`,
					]
				},
				options,
			};
			const statsLocationsChart = new Chart(ctx, config);
		}
	}

	function statsUsers() {
		const ctx = document.getElementById('statsUsers');
		if (ctx) {
			const {
				statManager,
				statFire,
				statUser,
				statOther,
				nameManager,
				nameFire,
				nameUser,
				nameOther,
			} = ctx.dataset;
			const config = {
				type: 'pie',
				data: {
					datasets: [{
						data: [
							Number(statManager),
							Number(statFire),
							Number(statUser),
							Number(statOther),
						],
						backgroundColor: [
							green,
							lriGreenDark,
							lriGreenLight,
							gray,
						],
					}],
					labels: [
						`${nameManager} (${Number(statManager)})`,
						`${nameFire} (${Number(statFire)})`,
						`${nameUser} (${Number(statUser)})`,
						`${nameOther} (${Number(statOther)})`,
					]
				},
				options,
			};
			const statsUsersChart = new Chart(ctx, config);
		}
	}

	function onTableActionClick({ currentTarget }) {
		let elt = $(currentTarget);
		let ctn = elt.closest('.dashboard-admin__content, .dashboard-manager__table');
		let toToggle = ctn.find('.table__tr_hide, .table__tr_to-hide');
		let isHidden = toToggle.hasClass('table__tr_hide');
		let { text } = currentTarget.dataset;
		let oldText = elt.find('span').text();

		toToggle.toggleClass('table__tr_hide', !isHidden);
		toToggle.toggleClass('table__tr_to-hide', isHidden);
		elt.find('span').text(text);
		currentTarget.dataset.text = oldText;
	}

	function onPauseBtnClick({ currentTarget }) {
		let { id } = currentTarget.dataset;
		let isPaused = currentTarget.classList.contains('dashboard-manager-location__pause-btn_paused');

		if (isPaused) {
			currentTarget.classList.remove('dashboard-manager-location__pause-btn_paused');
		} else {
			currentTarget.classList.add('dashboard-manager-location__pause-btn_paused');
		}

		$.ajax({
			url: '/action/manageGenData',
			type: 'POST',
			data: {
				id,
				field19: isPaused,
			}
		});
	}

	function drawBarChart(deficiencies = 0, pictures = 0, nfcs_not_scanned = 0) {
		if (deficiencies == 0 && pictures == 0 && nfcs_not_scanned == 0) {
			var barChartDiv = $("#barchart");
			barChartDiv.addClass("sb-white-bg");
			barChartDiv.html("<p class='sb-d-flexi sb-ai-center sb-jc-c sb-h100'>No concerns reported during selected dates</p>");
		} else {
			const data = google.visualization.arrayToDataTable([
				['Category', 'Count', { role: 'style' }],
				['Deficiencies', deficiencies, 'color: #FF5722; opacity: 0.8; stroke-color: #D84315; stroke-width: 2'], // Red-Orange for deficiencies
				['Pictures', pictures, 'color: #57A140; opacity: 0.8; stroke-color: #3d6838; stroke-width: 2'],
				['NFCs\nNot Scanned', nfcs_not_scanned, 'color: #FF9800; opacity: 0.8; stroke-color: #EF6C00; stroke-width: 2'] // Orange for NFCS not scanned
			]);

			const options = {
				title: 'Checklist Overview',
				legend: { position: 'none' }, // Hide the legend to focus on bars
				animation: {
					startup: true,
					duration: 1000,
					easing: 'out',
				},
				hAxis: {
					title: 'Categories',
					minValue: 0,
					textStyle: {
						fontSize: 14, // Adjust font size for categories
						bold: true, // Makes categories bold
						color: '#000' // Set color for category labels
					},
				},
				vAxis: {
					title: 'Count',
					textStyle: {
						fontSize: 12,
						color: '#555'
					},
				},
				backgroundColor: '#f1f1f1', // Light background
				bar: { groupWidth: '75%' }, // Adjust bar width
				tooltip: {
					isHtml: true, // Advanced tooltips
					trigger: 'focus',
				},
				annotations: {
					alwaysOutside: true, // Display values outside the bars
					textStyle: {
						fontSize: 12,
						bold: true,
						color: '#000',
					}
				}
			};

			const chart = new google.visualization.ColumnChart(document.getElementById('barchart'));
			chart.draw(data, options);
			google.visualization.events.addListener(chart, 'select', function () {
				document.getElementById('sb-table-two').scrollIntoView({
					block: "start",
					inline: "nearest",
					behavior: 'smooth'
				});
			});
		}
	}

	function drawPieChart(completed = 0, notCompleted = 0) {
		const total = completed + notCompleted;

		// Calculate percentages
		const completedPercentage = total > 0 ? ((completed / total) * 100).toFixed(1) : 0;
		const notCompletedPercentage = total > 0 ? ((notCompleted / total) * 100).toFixed(1) : 0;

		let tolerance = 0.0001;
		let isSingleSlice = Math.abs(completedPercentage - 100) < tolerance ||
			Math.abs(notCompletedPercentage - 100) < tolerance;

		// Update data with percentages in labels
		var data = google.visualization.arrayToDataTable([
			['Checklist', 'Total'],
			[`Completed`, completed < 0 ? 0 : completed],
			[`Not Completed`, notCompleted < 0 ? 0 : notCompleted],
		]);

		if (completed == 0 && notCompleted == 0) {
			var pieChartDiv = $("#piechart");
			pieChartDiv.removeClass("sb-w100").addClass("sb-white-bg sb-w99");
			pieChartDiv.html("<p class='sb-d-flexi sb-ai-center sb-jc-c sb-h100'>No activity reported during selected dates</p>");
		} else {
			var chart = new google.visualization.PieChart(document.getElementById('piechart'));
			const options = {
				title: 'Completion Status',
				titleTextStyle: {
					color: '#34495E',
					fontSize: 18,
					bold: true,
				},
				is3D: true, // Enable 3D effect
				colors: [lriGreen, red], // Completed (green), Not Completed (red)
				pieSliceText: 'percentage',
				legend: {
					position: 'right',
					textStyle: {
						color: '#34495E',
						fontSize: 14,
					},
				},
				animation: {
					startup: true,
					duration: 1200,
					easing: 'inAndOut',
				},
				backgroundColor: '#f1f1f1',
				chartArea: {
					width: '60%',
					height: '60%',
				},
				tooltip: {
					text: 'count',
					showColorCode: true,
					textStyle: {
						fontSize: 14,
						bold: true,
					},
				},
				slices: {
					0: {
						offset: 0.1, // Offset Completed slice for emphasis
						opacity: 0.8, // Reduce opacity to avoid blurriness
					},
					1: {
						opacity: 0.8, // Reduce opacity to avoid blurriness
					}
				},
			};

			if (isSingleSlice)
				options.is3D = false;
			chart.draw(data, options);

			google.visualization.events.addListener(chart, 'select', function () {
				var selectedItem = chart.getSelection()[0];
				if (selectedItem) {
					var name = data.getValue(selectedItem.row, 0);
					$("#collect").val(name == undefined ? "" : String(name).toLowerCase().replace(" ", "_")).trigger("change");

					loadGraph()

					document.getElementById('sb-table-one').scrollIntoView({
						block: "start",
						inline: "nearest",
						behavior: 'smooth'
					});
				}
			});
		}
	}

	function drawIncidentPieChart(incidentReports) {
		// Fixed colors for consistent mapping
		var colors = LRI_PIE_CHART_COLORS;

		// DataTable for Google Chart
		var data = new google.visualization.DataTable();
		data.addColumn('string', 'Incident Type');
		data.addColumn('number', 'Count');

		incidentReports.forEach(item => {
			data.addRow([item.incidentType, item.count]);
		});

		var options = {
			title: 'Incident Chart by Type',
			is3D: true,
			pieSliceText: 'percentage',
			legend: { position: 'right' },
			chartArea: { width: '70%', height: '70%' },
			colors: colors,
			backgroundColor: '#f1f1f1'
		};

		window.incidentChart = new google.visualization.PieChart(document.getElementById('incident-piechart'));
		window.incidentChartData = data;
		window.incidentColors = colors;
		window.incidentReports = incidentReports;

		incidentChart.draw(data, options);
	}

	function ensureShiftTableHeaderLayout() {
		if (document.getElementById('shift-table-header-layout-fix')) return;

		const style = document.createElement('style');
		style.id = 'shift-table-header-layout-fix';
		style.innerHTML = `
			#shiftTable_wrapper table.dataTable thead th {
				vertical-align: top;
			}

			#shiftTable_wrapper table.dataTable thead th .dt-column-title {
				display: block;
				line-height: 1.25;
				padding-right: 12px;
			}

			#shiftTable_wrapper table.dataTable thead th.sorting,
			#shiftTable_wrapper table.dataTable thead th.sorting_asc,
			#shiftTable_wrapper table.dataTable thead th.sorting_desc,
			#shiftTable_wrapper table.dataTable thead th.dt-orderable-asc,
			#shiftTable_wrapper table.dataTable thead th.dt-orderable-desc,
			#shiftTable_wrapper table.dataTable thead th.dt-ordering-asc,
			#shiftTable_wrapper table.dataTable thead th.dt-ordering-desc {
				padding-right: 28px !important;
				background-position: right 8px center;
			}

			#shiftTable_wrapper table.dataTable thead th input,
			#shiftTable_wrapper table.dataTable thead th select {
				position: static !important;
				display: block;
				width: 100%;
				margin-top: 6px;
			}
		`;

		document.head.appendChild(style);
	}

	function drawIncidentLineChart(incidentReports) {
		let dateRange = $('#incident_rangeDate').val();
		let locations = $('#incidentsList').val();
		let locationsStr = locations ? locations.join(',') : '';

		if (!locationsStr) {
			return;
		}

		$.ajax({
			url: '/action/fetchIncidentAnalytics',
			type: 'GET',
			data: {
				dateRange: dateRange,
				locations: locationsStr,
				flag: "0"
			},
			success: function (response) {
				// response is [["Date","Fire","Noise","Accident"],["2023-11-01",1,1,1],...]
				let header = response[0];

				// Replace zeros with null so chart skips flat baselines
				let rows = response.slice(1).map(row => {
					return [
						row[0],
						...row.slice(1).map(v => v === 0 ? null : v)
					];
				});

				let dataTable = new google.visualization.DataTable();
				dataTable.addColumn('string', header[0]);
				for (let i = 1; i < header.length; i++) {
					dataTable.addColumn('number', header[i]);
				}
				dataTable.addRows(rows);

				var options = {
					title: 'Incident Over Time',
					curveType: 'function',   // smooth curves
					legend: { position: 'bottom' },
					hAxis: {
						title: 'Date',
						slantedText: true,
						slantedTextAngle: 45,
						format: 'yyyy-MM-dd' // show full date
					},
					vAxis: {
						title: 'Number of Incidents'
					},
					pointSize: 5,
					colors: LRI_PIE_CHART_COLORS,
					backgroundColor: '#f1f1f1',
					interpolateNulls: true,   // connect gaps so you don’t see only dots
					width: '100%',            // 👈 bigger chart
					height: 600,
					chartArea: {
						left: 80,             // space for y-axis labels
						right: 40,
						top: 50,
						bottom: 120,          // space for slanted x-axis labels
						width: '100%',
						height: '70%'
					}
				};


				window.incidentChart = new google.visualization.LineChart(
					document.getElementById('incident-piechart')
				);
				incidentChart.draw(dataTable, options);

				window.incidentChart = incidentChart;
				window.incidentChartData = dataTable;
				window.incidentColors = options.colors;
				window.incidentReports = incidentReports;

				// incident types for dropdown (skip Date col)
				let allIncidentTypes = header.slice(1);

				// populate dropdown dynamically
				const dropdown = $('#incident-type-dropdown');
				dropdown.empty();
				allIncidentTypes.forEach(type => {
					dropdown.append(new Option(type, type));
				});

				// hook dropdown to filter chart
				setupLineChartFilter(dataTable, allIncidentTypes);
			},
			error: function () {
				alert("Failed to load incident trends");
			}
		});
	}

	function drawIncidentBarChart(incidentReports) {
		// 🔹 Step 1: Extract all unique incident types, or use empty array if null/empty
		let allIncidentTypes = incidentReports && incidentReports.length > 0
			? [...new Set(incidentReports.map(r => r.incidentType))]
			: [];

		// 🔹 Step 2: Prepare rows for Google chart
		let dataRows = allIncidentTypes.length > 0
			? allIncidentTypes.map(type => {
				let total = incidentReports
					.filter(r => r.incidentType === type)
					.reduce((sum, r) => sum + r.count, 0);
				return [type, total];
			})
			: []; // empty rows if no incidentReports

		// 🔹 Step 3: Create DataTable
		let dataTable = new google.visualization.DataTable();
		dataTable.addColumn('string', 'Incident Type');
		dataTable.addColumn('number', 'Count');
		if (dataRows.length > 0) dataTable.addRows(dataRows);

		// 🔹 Step 4: Chart options
		let options = {
			title: 'Incident Counts',
			titleTextStyle: { color: '#1e3a8a', fontSize: 20, bold: true },
			hAxis: { title: 'Incident Type', slantedText: true, slantedTextAngle: 45, textStyle: { color: '#111827', fontSize: 12 } },
			vAxis: { title: 'Number of Incidents', format: '0', minValue: 0, textStyle: { color: '#111827', fontSize: 12 }, gridlines: { color: '#e5e7eb' } },
			backgroundColor: '#f1f1f1',
			legend: { position: 'none' },
			bar: { groupWidth: '60%' },
			animation: { startup: true, duration: 1000, easing: 'out' },
			colors: LRI_PIE_CHART_COLORS,
			width: '100%',
			height: 600,
			chartArea: { left: 80, right: 40, top: 50, bottom: 120, width: '100%', height: '70%' }
		};

		// 🔹 Step 5: Draw chart
		let chart = new google.visualization.ColumnChart(document.getElementById('incident-piechart'));
		chart.draw(dataTable, options);

		// 🔹 Step 6: Save globally if needed
		window.incidentChart = chart;
		window.incidentChartData = dataTable;
		window.incidentColors = options.colors;
		window.incidentReports = incidentReports || [];

		// 🔹 Step 7: Populate dropdown for filtering
		const dropdown = $('#incident-type-dropdown');
		dropdown.empty();
		allIncidentTypes.forEach(type => dropdown.append(new Option(type, type)));

		// 🔹 Step 8: Optional filter setup
		setupLineChartFilter(dataTable, allIncidentTypes);

		loadDataUsingParams("#incident_rangeDate", incidentReport);
	}


	function drawShiftLineChart() {
		let dateRange = $('#shift_rangeDate').val();
		let locations = $('#shiftsList').val();
		let locationsStr = locations ? locations.join(',') : '';

		if (!locationsStr) {
			return;
		}

		$.ajax({
			url: '/action/fetchShiftAnalytics',
			type: 'GET',
			data: {
				dateRange: dateRange,
				locations: locationsStr,
				flag: '0'
			},
			success: function (response) {
				// response looks like:
				// [["Date","Hanzala","Younis"],["2023-09-08",5,2],["2023-09-09",3,4]]

				let header = response[0];

				// Replace zeros with null so chart skips flat baselines
				let rows = response.slice(1).map(row => {
					return [
						row[0],
						...row.slice(1).map(v => v === 0 ? null : v)
					];
				});

				let dataTable = new google.visualization.DataTable();
				dataTable.addColumn('string', header[0]);
				for (let i = 1; i < header.length; i++) {
					dataTable.addColumn('number', header[i]);
				}
				dataTable.addRows(rows);

				var options = {
					title: 'Shift Logs Over Time',
					curveType: 'function',
					legend: { position: 'bottom' },
					hAxis: {
						title: 'Date',
						slantedText: true,
						slantedTextAngle: 45,
						format: 'yyyy-MM-dd'
					},
					vAxis: {
						title: 'Number of Logs'
					},
					pointSize: 5,
					colors: LRI_PIE_CHART_COLORS,
					backgroundColor: '#f1f1f1',
					interpolateNulls: true,
					width: 1300,
					height: 600,
					chartArea: {
						left: 80,
						right: 40,
						top: 50,
						bottom: 120,
						width: '100%',
						height: '70%'
					}
				};

				// ✅ Draw chart
				let chart = new google.visualization.LineChart(
					document.getElementById('shift-barchart')
				);
				chart.draw(dataTable, options);

				// ✅ Expose for PDF export
				window.shiftChart = chart;
				window.shiftChartData = dataTable;
				window.shiftColors = options.colors;
			},
			error: function () {
				alert("Failed to load shift trends");
			}
		});
	}

	function shiftCloseDetails() {
		shiftDetailsPopup.find('.stool-shared-popup-close-btn').off('click', shiftCloseDetails);
		$(document.body).removeClass('shift-details-print');
		shiftDetailsPopup.removeClass('visible');
	}

	function setupLineChartFilter(dataTable, allIncidentTypes) {
		const incidentDropDown = $('#incident-type-dropdown');

		incidentDropDown.off('change').on('change', function () {
			const selectedTypes = $(this).val();
			let view = new google.visualization.DataView(dataTable);

			// Always keep Date column
			let columns = [0];

			if (selectedTypes && selectedTypes.length > 0) {
				selectedTypes.forEach(type => {
					const colIndex = allIncidentTypes.indexOf(type) + 1; // +1 because Date is col 0
					if (colIndex > 0) columns.push(colIndex);
				});
			} else {
				// if nothing selected → show all columns
				columns = Array.from({ length: dataTable.getNumberOfColumns() }, (_, i) => i);
			}

			view.setColumns(columns);

			var dateTicks = dataTable.getDistinctValues(0); // get all unique dates from column 0

			var options = {
				title: 'Incident Trends Over Time',
				curveType: 'function',
				legend: { position: 'bottom' },
				hAxis: {
					title: 'Date',
					slantedText: true,
					slantedTextAngle: 45,
					format: 'yyyy-MM-dd',
					ticks: dateTicks   // force exact dates
				},
				vAxis: {
					title: 'Number of Incidents'
				},
				pointSize: 5,
				backgroundColor: '#f1f1f1'
			};


			window.incidentChart.draw(view, options);
		});



		// initialize Select2
		incidentDropDown.select2({
			allowClear: true,
			width: '100%',
			closeOnSelect: false,
			multiple: true,
			dropdownAutoWidth: true,
			containerCssClass: 'sb-prelated',
			dropdownCssClass: 'form-input input'
		});
	}



	function drawShiftBarChart(dataArray, type) {
		var data = new google.visualization.DataTable();

		if (type === "0") {
			data.addColumn('string', 'Person Name');
			data.addColumn('number', 'Total Hours');

			let aggregatedData = {};
			dataArray.forEach(item => {
				if (!aggregatedData[item.name]) aggregatedData[item.name] = 0;
				aggregatedData[item.name] += item.durationHours;
			});

			for (var key in aggregatedData) {
				data.addRow([key, aggregatedData[key]]);
			}
		} else {
			data.addColumn('string', 'Log Date');
			data.addColumn('number', 'Log Count');

			dataArray.forEach(item => {
				data.addRow([item.logDate, item.logCount]);
			});
		}

		var options = {
			title: type === "0" ? 'Shift Hours by Person' : 'Log Counts by Date',
			titleTextStyle: { color: '#1e3a8a', fontSize: 20, bold: true },
			hAxis: { title: type === "0" ? 'Person' : 'Date', titleTextStyle: { color: '#374151', fontSize: 14, bold: true }, textStyle: { color: '#111827', fontSize: 12 } },
			vAxis: { title: type === "0" ? 'Total Hours' : 'Log Count', minValue: 0, titleTextStyle: { color: '#374151', fontSize: 14, bold: true }, textStyle: { color: '#111827', fontSize: 12 }, gridlines: { color: '#e5e7eb' } },
			legend: { position: 'none' },
			backgroundColor: '#f1f1f1',
			bar: { groupWidth: '60%' },
			colors: [lriGreen],
			animation: { startup: true, duration: 1200, easing: 'out' }
		};

		window.shiftChart = new google.visualization.ColumnChart(
			document.getElementById('shift-barchart')
		);
		window.shiftChart.draw(data, options);

		window.shiftChartData = data;
		window.shiftReportData = dataArray;
		window.shiftType = type;


		loadDataUsingParams("#shift_rangeDate", shiftReport);
	}

	function loadDataUsingParams(rangeKey, callback) {
		if (isIncidentReportRunning) return;
		isIncidentReportRunning = true;

		const urlParams = new URLSearchParams(window.location.search);
		const dateRange = urlParams.get("dateRange");
		const locations = urlParams.get("locationId");

		// ✅ Only run if both dateRange and locations exist
		if (dateRange && locations) {

			if ($("#rangeDate").length) {

				$('#checklistsList1 option').prop('selected', false);
				$('#checklistsList1 option').prop('selected', true);

				var selectedValues = $('#checklistsList1').val(); // array of all values
				var selectedString = selectedValues ? selectedValues.join(',') : '';
				$('#checklists').val(selectedString);
			}

			const [start, end] = dateRange.split("_to_");

			const toLocalDate = (str) => {
				const [y, m, d] = str.split("-").map(Number);
				return new Date(y, m - 1, d);
			};

			const startDate = toLocalDate(start);
			const endDate = toLocalDate(end);

			const opts = { year: "numeric", month: "long", day: "numeric" };
			const formatted = `${startDate.toLocaleDateString("en-US", opts)} - ${endDate.toLocaleDateString("en-US", opts)}`;
			$(rangeKey).val(formatted).trigger("change");

			callback();

		}
	}

	function saveAnalytics(e) {
		var obj = {};
		var requiredFields = "";
		$(".reminder-field:not(.updated-select-input-hidden)").map((i, ele) => {
			const o = $(ele);
			var name = o.attr("name");
			if (o.hasClass("form-select")) {
				obj[name] = o.find(":selected").val();

			} else if (o.hasClass("form-input") || o.attr("type") == "hidden") {
				if (!o.parent().parent().hasClass("sb-d-none") && o.hasClass("required") && (o.hasClass("error") || o.val() == "")) {
					requiredFields += requiredFields == "" ? o.parent().siblings(".form-input-label").find("span").text() : ", " + o.parent().siblings(".form-input-label").find("span").text();
					if (!o.hasClass("error"))
						o.addClass("error");
				}
				obj[name] = o.val();
			} else if (o.hasClass("form-check-input") || o.hasClass("form-radio-input")) {
				if (o.is(":checked"))
					if (o.hasClass("response-forward__person-check")) {
						const val = o.attr("data-field2");
						obj[name] = (name in obj) ? obj[name] + "," + val : val;
					} else if (!o.hasClass("response-forward__person-check")) {
						const val = o.attr("value");
						obj[name] = (name in obj) ? obj[name] + "," + val : val;
					}
			}
		});


		if (String(requiredFields).length > 0) {
			alert("Please fill are required fields... missing fields: " + requiredFields);
		} else {
			postReqV2(obj, "save-reminder-setup",
				function (response) {
					var res = response;
					$($($(e.currentTarget).attr("data-target"))).removeClass("show");
					location.reload();
				}, function () {
					$($($(e.currentTarget).attr("data-target"))).removeClass("show");
				}
			);
		}
	}

	function init() {
		/* ── Calendar widget iframe auto-resize ── */
		window.addEventListener('message', function(e) {
			if (e.data && e.data.type === 'calendar-widget-resize' && e.data.height) {
				var iframe = document.getElementById('calendarWidgetIframe');
				if (iframe) iframe.style.height = Math.max(e.data.height, 200) + 'px';
			}
		});

		shiftDetailsPopup = $('.shift-details');
		$('.shift-details__close').on('click', shiftCloseDetails);
		$(document).on('click', '.shift-details-updated-btn', populateShiftDetails);
		$('.shift-details__print').on('click', exportModalToPDF);
		$('.incident-details__print').on('click', exportModalToPDF);
		document.querySelectorAll('.accordion__item').forEach(item => {
			const body = item.querySelector('.accordion__body');

			// Watch for changes in the body
			const observer = new MutationObserver(() => {
				if (item.classList.contains('active')) {
					// Recalculate height when content changes
					body.style.maxHeight = body.scrollHeight + 'px';
				}
			});

			observer.observe(body, { childList: true, subtree: true });
		});

		document.querySelectorAll('.accordion__header').forEach(header => {
			header.addEventListener('click', () => {
				const item = header.parentElement;
				const body = item.querySelector('.accordion__body');

				if (item.classList.contains('active')) {
					// collapse
					body.style.maxHeight = '0';
					body.style.padding = '0 20px';
					item.classList.remove('active');
				} else {
					// collapse others (optional)
					document.querySelectorAll('.accordion__item.active').forEach(activeItem => {
						activeItem.classList.remove('active');
						const activeBody = activeItem.querySelector('.accordion__body');
						activeBody.style.maxHeight = '0';
						activeBody.style.padding = '0 20px';
					});

					// expand clicked accordion
					item.classList.add('active');
					body.style.padding = '20px';
					body.style.maxHeight = body.scrollHeight + 'px'; // ← dynamic height
				}
			});
		});

		if (window.location.pathname === '/' || window.location.pathname === '/home') {

			const accordion = document.getElementById('ceoReportAccordion');
			if (accordion) {
				Sortable.create(accordion, {
					handle: '.drag-handle', // only drag by handle
					animation: 150,
					ghostClass: 'sortable-ghost'
				});
			}

		}

		$("#incidentSearchBtn").on("click", incidentReport);
		$("#shiftSearchBtn").on("click", shiftReport);
		$('#shift-type-dropdown').on('change', shiftReport);
		utils = Fw.component.models().utils;

		if (window.location.pathname.includes("geofence")) {


			const domain = window.location.hostname;
			let url = "";

			if (domain === "localhost") {
				url = `http://localhost:9105`;
			} else {
				url = `/geofence-service`;
			}

			// Shared Select2 config for checkbox multi-select dropdowns
			function geofenceSelect2Multi($el, placeholder) {
				$el.select2({
					placeholder: placeholder,
					allowClear: true,
					closeOnSelect: false,
					templateResult: function (data) {
						if (!data.id) return data.text;
						var isSelected = (data.element && data.element.selected) ? 'checked' : '';
						var $el = $('<span style="display:flex;align-items:center;gap:6px;"><input type="checkbox" ' + isSelected + ' style="pointer-events:none;margin:0;"/>' + data.text + '</span>');
						return $el;
					},
					templateSelection: function (data, container) {
						var $sel = $el;
						var count = $sel.val() ? $sel.val().length : 0;
						if (count === 0) return placeholder;
						if (count === 1) return data.text;
						return count + ' selected';
					}
				});
				// Keep dropdown open and update checkbox visuals on select/unselect
				$el.on('select2:select select2:unselect', function () {
					var vals = $(this).val() || [];
					// Refresh displayed text
					$(this).trigger('change.select2');
					// Update checkbox states in open dropdown
					setTimeout(function () {
						$el.data('select2').$dropdown.find('.select2-results__option').each(function () {
							var isAria = $(this).attr('aria-selected') === 'true';
							$(this).find('input[type=checkbox]').prop('checked', isAria);
						});
					}, 0);
				});
			}

			let fullNameList = new Set();
			let locationNameList = new Set();
			let createdAtCache = [];

			// Populate location dropdown from API (same as report-settings)
			$.ajax({
				url: `${url}/public/get-locations`,
				method: 'get',
				data: { personId: $('#geofencePersonId').val() },
				dataType: 'json',
				success: function (response) {
					var content = response.content || [];
					var locationOptions = content.map(function (loc) {
						return { id: loc.name, text: loc.name };
					});
					var $locSelect = $('#locationNameFilter');
					locationOptions.forEach(function (opt) {
						$locSelect.append('<option value="' + opt.id + '">' + opt.text + '</option>');
					});
					geofenceSelect2Multi($locSelect, 'Filter by Location');
				},
				error: function () {
					console.warn('Failed to load locations');
				}
			});

			const table = $('#geofenceTable').DataTable({
				ajax: {
					url: `${url}/public/geofence-report`,
					dataSrc: '',
					data: function (d) {
						d.personId = $('#geofencePersonId').val();
					}
				},
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: [
							'pageLength',
							{
								extend: 'collection',
								text: 'Download',
								attr: {
									class: "dt-button buttons-collection dt-download-btn",
								},
								buttons: [
									{
										text: 'Export Selected to PDF',
										action: function (e, dt, button, config) {

											// ------------------------------------------------------
											// 1. Inject CSS once (shared by all export buttons)
											// ------------------------------------------------------
											if (!document.getElementById("dt-dropdown-spinner-style")) {
												const style = document.createElement("style");
												style.id = "dt-dropdown-spinner-style";
												style.innerHTML = `
													.dt-dropdown-spinner {
														display: flex;
														justify-content: center;
														align-items: center;
														padding: 10px;
														font-size: 14px;
														font-weight: 500;
														color: #444;
														gap: 8px;
													}
													.dt-dropdown-spinner .loader {
														border: 3px solid #eee;
														border-top: 3px solid #3498db;
														border-radius: 50%;
														width: 16px;
														height: 16px;
														animation: spin 0.9s linear infinite;
													}
													@keyframes spin {
														0% { transform: rotate(0deg); }
														100% { transform: rotate(360deg); }
													}
												`;
												document.head.appendChild(style);
											}

											// ------------------------------------------------------
											// 2. Show spinner inside dropdown
											// ------------------------------------------------------
											const dropdown = document.querySelector(".dt-button-collection");

											if (dropdown) {
												// Remove old spinner if exists
												const old = dropdown.querySelector(".dt-dropdown-spinner");
												if (old) old.remove();

												// Create fresh spinner element
												const spinnerDiv = document.createElement("div");
												spinnerDiv.className = "dt-dropdown-spinner";
												spinnerDiv.innerHTML = `
													<div class="loader"></div>
													Exporting Selected...
												`;

												// Insert spinner at top of dropdown menu
												const menu = dropdown.querySelector("[role='menu']");
												if (menu) menu.prepend(spinnerDiv);
											}

											// ------------------------------------------------------
											// 3. Collect selected row IDs
											// ------------------------------------------------------
											const selectedLocIds = [];

											dt.rows().nodes().to$().each(function () {
												const $checkbox = $(this).find('input.row-select');
												if ($checkbox.prop('checked')) {
													const rowData = dt.row(this).data();
													if (rowData.locId) {
														selectedLocIds.push(rowData.locId);
													}
												}
											});

											if (selectedLocIds.length === 0) {
												removeSpinner();
												alert("⚠️ Please select at least one row before exporting to PDF.");
												return;
											}

											// ------------------------------------------------------
											// 4. Call backend API to generate PDF
											// ------------------------------------------------------
											fetch(`${url}/public/export-pdf`, {
												method: 'POST',
												headers: {
													'Content-Type': 'application/json'
												},
												body: JSON.stringify({ ids: selectedLocIds })
											})
												.then(response => {
													if (!response.ok) {
														throw new Error("Failed to generate PDF");
													}
													return response.blob();
												})
												.then(blob => {
													const blobUrl = window.URL.createObjectURL(blob);
													const link = document.createElement('a');
													link.href = blobUrl;
													link.download = 'Geofence_Report.pdf';
													document.body.appendChild(link);
													link.click();
													link.remove();
													window.URL.revokeObjectURL(blobUrl);
												})
												.catch(error => {
													console.error("PDF export error:", error);
													alert("❌ Failed to export PDF. Please try again.");
												})
												.finally(() => {
													removeSpinner();
												});

											// ------------------------------------------------------
											// 5. Remove spinner from dropdown
											// ------------------------------------------------------
											function removeSpinner() {
												const dropdown = document.querySelector(".dt-button-collection");
												if (!dropdown) return;

												const spinner = dropdown.querySelector(".dt-dropdown-spinner");
												if (spinner) spinner.remove();
											}
										}
									},
									{ extend: 'excelHtml5', text: 'Export to Excel' },
									{ extend: 'csvHtml5', text: 'Export to CSV' },

								]
							}
						]
					}
				},
				columns: [
					{
						data: null,
						title: '<input type="checkbox" id="select-all">',
						orderable: false,
						className: 'select-checkbox',
						defaultContent: '<input type="checkbox" class="row-select">'
					},
					{
						data: 'locationTime',
						render: function (data, type, row, meta) {
							const date = new Date(data);
							createdAtCache[meta.row] = date;
							row._createdAtDate = date;
							return date.toLocaleString('en-GB', {
								year: 'numeric',
								month: '2-digit',
								day: '2-digit',
								hour: '2-digit',
								minute: '2-digit',
								second: '2-digit',
								hour12: false
							});
						}
					},
					{ data: 'fullName' },
					{
						data: null,
						title: 'Map',
						orderable: false,
						render: function (data, type, row) {
							const link = `${url}/public/view/map?lat=${row.lat}&lng=${row.lng}&personId=${row.personId}&locationId=${row.locationName}`;

							if (type === 'display') {
								return `<a href="${link}" target="_blank" class="view-map-btn">View Map</a>`;
							}

							// Export raw link (CSV, Excel, PDF)
							return link;
						}
					},

					{ data: 'locationName' },
					{
						data: 'outOfGeofence',
						render: function (data) {
							return data
								? '<span style="padding:4px 10px;border-radius:12px;font-size:12px;color:#fff;font-weight:500;background-color:#dc3545;">offsite</span>'
								: '<span style="padding:4px 10px;border-radius:12px;font-size:12px;color:#fff;font-weight:500;background-color:#28a745;">onsite</span>';
						}
					},
					{
						data: null,
						title: 'Map Link (Hidden)',
						visible: false,
						render: function (data, type, row) {
							return `${url}/public/view/map?lat=${row.lat}&lng=${row.lng}&personId=${row.personId}&locationId=${row.locationId}`;
						}
					}
				],
				// columnDefs: [
				// 	{ targets: [7], visible: false } // locationName hidden but searchable
				// ],
				initComplete: function () {
					const data = table.rows().data().toArray();

					data.forEach(row => {
						fullNameList.add(row.fullName);
					});

					// Populate Full Name Select2 filter from data
					var $nameSelect = $('#fullNameFilter');
					[...fullNameList].forEach(function (name) {
						$nameSelect.append('<option value="' + name + '">' + name + '</option>');
					});
					geofenceSelect2Multi($nameSelect, 'Filter by Username');
				}
			});

			$('#geofenceTable thead').on('click', '#select-all', function () {
				const isChecked = $(this).prop('checked');
				$('#geofenceTable tbody input.row-select').prop('checked', isChecked);
			});


			let dateRange = [null, null];

			$('#dateRange').daterangepicker({
				autoUpdateInput: false,
				locale: {
					cancelLabel: 'Clear',
					format: 'MMMM Do, YYYY'
				}
			});

			$('#dateRange').on('apply.daterangepicker', function (ev, picker) {
				dateRange = [picker.startDate.toDate(), picker.endDate.toDate()];
				$(this).val(picker.startDate.format('MMMM Do, YYYY') + ' - ' + picker.endDate.format('MMMM Do, YYYY'));
				table.draw();
			});

			$('#dateRange').on('cancel.daterangepicker', function () {
				$(this).val('');
				dateRange = [null, null];
				table.draw();
			});

			$('#fullNameFilter, #locationNameFilter').on('change', function () {
				table.draw();
			});

			// Custom filter for all 3 fields
			$.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
				const createdAt = createdAtCache[dataIndex];
				const fullName = table.row(dataIndex).data().fullName;
				const locationName = table.row(dataIndex).data().locationName;

				// Date filter
				if (dateRange[0] && dateRange[1]) {
					if (createdAt < dateRange[0] || createdAt > dateRange[1]) {
						return false;
					}
				}

				// Name filter
				const selectedNames = $('#fullNameFilter').val();
				if (selectedNames && selectedNames.length && !selectedNames.includes(fullName)) {
					return false;
				}

				// Location filter
				const selectedLocations = $('#locationNameFilter').val();
				if (selectedLocations && selectedLocations.length && !selectedLocations.includes(locationName)) {
					return false;
				}

				return true;
			});

		}


		// Get URL params
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get("token");
		const appParam = urlParams.get("app"); // your new parameter

		// Trigger progress bar if token exists OR app=webapp
		if (token || window.self !== window.top) {
			// Simulated progress (make globally accessible)
			window.progressBar = document.querySelector("#progress-bar");
			window.progressLabel = document.querySelector("#progress-label");
			window.progress = 0;

			window.progressInterval = setInterval(() => {
				window.progress += Math.random() * 10;
				if (window.progress >= 90) {
					window.progress = 90;
					clearInterval(window.progressInterval);
				}

				const percent = Math.floor(window.progress);
				if (window.progressBar) window.progressBar.style.width = percent + "%";
				if (window.progressLabel) window.progressLabel.textContent = percent + "%";
			}, 200);

			// Only fetch session if token exists
			if (token) {
				fetch(`/action/sbGetSession?token=${token}`)
					.then(res => res.json())
					.then(data => {
						if (data.sessionId) {
							document.cookie = 'JSESSIONID=' + data.sessionId + '; path=/; secure; samesite=strict;';
							window.history.replaceState({}, document.title, window.location.pathname);
							startDashboardCheck();
						}
					})
					.catch(err => console.error("Session fetch error:", err));
			} else {
				// No token, but still check dashboard for progress completion
				startDashboardCheck();
			}

			function startDashboardCheck() {
				const checkDashboardLoaded = setInterval(function () {
					const dashboardHeader = document.querySelector("h1.table-page-inner__title");
					if (dashboardHeader && dashboardHeader.textContent.includes("Kera Insight")) {
						clearInterval(checkDashboardLoaded);

						// Complete progress bar
						if (window.progressInterval) clearInterval(window.progressInterval);
						if (window.progressBar) window.progressBar.style.width = "100%";
						if (window.progressLabel) window.progressLabel.textContent = "100%";

						setTimeout(function () {
							const loader = document.getElementById("custom-preloader");
							if (loader) loader.remove();
						}, 300);
					}
				}, 300);
			}
		}


		$('.save-analytics-reminders').on('click', saveAnalytics);

		if (localStorage.getItem("rangeDate") !== null)
			$("#rangeDate").val(localStorage.getItem("rangeDate"));

		if (localStorage.getItem("locIds") !== null)
			$("#locIds").val(localStorage.getItem("locIds"));

		var counter = 0;
		if (localStorage.getItem("checklists") !== null) {
			$("#checklists").val(localStorage.getItem("checklists"));
			var checklists = $("#checklists").val();
			$("#checklistsList1").find("option").each((i, v) => {
				const ele = $(v);
				const optVal = ele.attr("value");
				if (String("," + checklists + ",").indexOf("," + optVal + ",") !== -1) {
					counter++;
					ele.attr("selected", "selected");
				}
			});
		} else {
			$("#checklistsList1").find("option").each((i, v) => {
				var ele = $(v);
				ele.attr("selected", "selected");
			});
			counter = $("#checklistsList1").find("option").length;
		}

		if (localStorage.getItem("collect") !== null)
			$("#collect").val(localStorage.getItem("collect"));
		$("#checklists-text").val("(" + counter + ") selected");

		if (window.self !== window.top) {
			const pieChartDiv = document.getElementById("piechartDiv");
			if (pieChartDiv) {
				const piechartDiv = document.getElementById('piechartDiv');
				const sbTableOne = document.getElementById('sb-table-one');

				if (piechartDiv && sbTableOne) {
					const children = Array.from(piechartDiv.children);

					if (children.length >= 2) {
						// const firstDiv = children[0]; // first child of piechartDiv
						const secondDiv = children[1]; // second child of piechartDiv

						// Move firstDiv after sb-table-one
						// sbTableOne.insertAdjacentElement('beforeend', firstDiv);

						// Move secondDiv after firstDiv (now already moved)
						sbTableOne.insertAdjacentElement('afterend', secondDiv);
					}
				}
			}
		}

		if (window.location.pathname === '/' || window.location.pathname === '/home') {

			populateTreeSelect();
		}
		// initializeISelectMultiple($("#checklistsList1"),"#checklists","#checklists-text","(",") selected");
		// initializeISelectMultiple($("#checklistsList2"),"#rChecklists",undefined,"(",") selected");

		const rangeDate = $("#rangeDate").val();
		const startDate = rangeDate ? moment(rangeDate.split(" - ")[0], dateFormat) : moment().subtract(6, 'days');
		const endDate = rangeDate ? moment(rangeDate.split(" - ")[1], dateFormat) : moment();

		statsUsers();
		statsLocations();

		$('[data-datepicker=separateRange]').daterangepicker({
			locale: { format: dateFormat },
			ranges: {
				'Today': [moment(), moment()],
				'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
				'Last 7 Days': [moment().subtract(6, 'days'), moment()],
				'Last 30 Days': [moment().subtract(29, 'days'), moment()],
				'Last 90 Days': [moment().subtract(90, 'days'), moment()],
				'Last 180 Days': [moment().subtract(180, 'days'), moment()],
				'Last 12 Month': [moment().subtract(365, 'days'), moment()],
				'This Month': [moment().startOf('month'), moment().endOf('month')],
				'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
			},
			startDate: startDate,
			endDate: endDate
		});

		loadGraph(false);
		$('.dashboard-manager__table-action').on('click', onTableActionClick)
		$('.dashboard-manager-location__pause-btn').on('click', onPauseBtnClick);
		$(document).on("click", ".response-details-updated-btn", populateDetails);

		/* ── Calendar collapse toggle ── */
		$('.js-collapse-toggle').on('click', function () {
			var targetId = $(this).data('target');
			var $target = $('#' + targetId);
			var $chevron = $(this).find('.collapse-chevron');
			$target.slideToggle(250, function () {
				if ($target.is(':visible')) {
					$chevron.css('transform', 'rotate(180deg)');
				} else {
					$chevron.css('transform', 'rotate(0deg)');
				}
			});
		});

		loadLogoAsBase64((imgSource) => {
			var image = new Image();
			image.src = imgSource;
			image.id = "logoBase64";
			image.classList.add("d-none");

			if ($("body").find("#logoBase64"))
				$("body").find("#logoBase64").remove();

			$("body").prepend(image);
		})

	}

	async function exportModalToPDF({ currentTarget }) {
		var type = "";
		if (currentTarget.className.includes("shift")) {
			type = "shift";
		} else {
			type = "incident";
		}

		const button = document.querySelector(`.${type}-details__print`);
		const rowId = button.dataset.rowId;
		let userId = document.getElementById("userId");

		// Build URL
		const baseUrl = window.location.origin;
		const domain = window.location.hostname;
		let url = domain === "localhost"
			? `http://localhost:9101/public/export/modal/${type}?${type}Id=${rowId}`
			: `${baseUrl}/analyticservice/public/export/modal/${type}?${type}Id=${rowId}`;

		// Inject CSS for spinner only once
		if (!document.getElementById("spinner-style")) {
			const style = document.createElement("style");
			style.id = "spinner-style";
			style.innerHTML = `
			.btn-spinner {
				width: 18px;
				height: 18px;
				border: 2px solid #fff;
				border-top-color: #54834D;
				border-radius: 50%;
				animation: spin 0.6s linear infinite;
				display: inline-block;
				vertical-align: middle;
			}
			@keyframes spin {
				to { transform: rotate(360deg); }
			}
		`;
			document.head.appendChild(style);
		}

		try {
			// Show spinner
			button.disabled = true;
			button.innerHTML = `<span class="btn-spinner"></span>`;

			const response = await fetch(url, { method: "GET" });

			if (!response.ok) throw new Error("Failed to fetch PDF");

			const blob = await response.blob();
			const link = document.createElement("a");
			link.href = window.URL.createObjectURL(blob);
			link.download = "response.pdf";
			link.click();

			window.URL.revokeObjectURL(link.href);
		} catch (err) {
			console.error("PDF download failed:", err);
			alert("❌ PDF download failed. Please try again.");
		} finally {
			// Restore button
			button.disabled = false;
			button.textContent = "Download";
		}
	}

	// Collect unique incidentType strings from the JSON data
	function getUniqueIncidentTypes(data) {
		const typeSet = new Set();
		data.forEach(item => {
			if (item.incidentType) {
				typeSet.add(item.incidentType.trim()); // keep full string
			}
		});
		return Array.from(typeSet).sort(); // convert Set to sorted array
	}

	// Populate dropdown with the unique incidentType strings
	function populateIncidentDropdown(data) {
		const incidentTypeOptions = getUniqueIncidentTypes(data);
		const dropdown = document.getElementById('incident-type-dropdown');

		// Optional: add default "All" option
		dropdown.innerHTML = '<option value="">All Incident Types</option>';

		incidentTypeOptions.forEach(type => {
			const option = document.createElement('option');
			option.value = type;
			option.text = type;
			dropdown.appendChild(option);
		});
	}

	function setupLineChartFilter(dataTable, allIncidentTypes) {
		const incidentDropDown = $('#incident-type-dropdown');

		incidentDropDown.off('change').on('change', function () {
			const selectedTypes = $(this).val();
			let view = new google.visualization.DataView(dataTable);

			// Always keep Date column
			let columns = [0];

			if (selectedTypes && selectedTypes.length > 0) {
				selectedTypes.forEach(type => {
					const colIndex = allIncidentTypes.indexOf(type) + 1; // +1 because Date is col 0
					if (colIndex > 0) columns.push(colIndex);
				});
			} else {
				// if nothing selected → show all columns
				columns = Array.from({ length: dataTable.getNumberOfColumns() }, (_, i) => i);
			}

			view.setColumns(columns);

			let options = {
				title: 'Incident Trends Over Time',
				curveType: 'function',
				legend: { position: 'bottom' },
				hAxis: {
					title: 'Date',
					format: 'MMM d, yyyy',
					slantedText: true,
					slantedTextAngle: 45,
					showTextEvery: 1
				},
				vAxis: { title: 'Number of Incidents' },
				pointSize: 5,
				backgroundColor: '#f1f1f1'
			};

			window.incidentChart.draw(view, options);
		});

		// initialize Select2
		incidentDropDown.select2({
			allowClear: true,
			width: '100%',
			closeOnSelect: false,
			multiple: true,
			dropdownAutoWidth: true,
			containerCssClass: 'sb-prelated',
			dropdownCssClass: 'form-input input'
		});
	}


	function filterByIncidentType() {
		const table = $('#incidentTable').DataTable();
		const incidentDropDown = $('#incident-type-dropdown');

		// Add custom filter once
		$.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
			const selectedTypes = $('#incident-type-dropdown').val();
			if (!selectedTypes || selectedTypes.length === 0) return true;

			const typesArray = Array.isArray(selectedTypes) ? selectedTypes : [selectedTypes];

			// Since you configured columns with { data: 'incidentType' }
			const incidentType = data[3];  // object-based access

			return typesArray.includes(incidentType);
		});

		// Trigger redraw + pie chart on dropdown change
		incidentDropDown.on('change', function () {
			table.draw();
			const filteredData = table.rows({ search: 'applied' }).data().toArray();
			drawIncidentPieChart(filteredData);
		});

		// Initialize Select2 on your dropdown
		$('#incident-type-dropdown').select2({
			placeholder: null,
			allowClear: true,
			width: '100%',
			dropdownAutoWidth: true,
			closeOnSelect: false,
			multiple: true,
			containerCssClass: 'sb-prelated',
			dropdownCssClass: 'form-input input'
		});

		const style = document.createElement('style');
		style.innerHTML = `
.select2-container--default .select2-selection--multiple {
	min-height: 46px !important;
	border: 1px solid #cbccd9;
}
`;
		document.head.appendChild(style);


	}

	// Initialize DataTable
	function incidentReport() {

		google.charts.load('current', { 'packages': ['corechart'] });

		google.charts.setOnLoadCallback(function () {
			let dateRange = $('#incident_rangeDate').val();
			let locations = $('#incidentsList').val();
			let locationsStr = locations ? locations.join(',') : '';

			// Destroy existing table if exists
			if ($.fn.DataTable.isDataTable('#incidentTable')) {
				$('#incidentTable').DataTable().destroy();
			}

			if (!locationsStr) {
				$('#incidentTable').empty();
				return;
			}

			$('#incidentTable').DataTable({
				ajax: {
					url: '/action/fetchIncidentAnalytics',
					type: 'GET',
					data: {
						dateRange: dateRange,
						locations: locationsStr
					},
					dataSrc: '',
					error: function () {
						errorCallback();
					}
				},
				layout: {
					topStart: {
						buttons: [
							'pageLength',
							{
								extend: 'collection',
								text: 'Download',
								attr: {
									class: "dt-button buttons-collection dt-download-btn",
								},
								buttons: [
									{
										text: 'Export PDF',
										action: function (e, dt, button, config) {

											// ------------------------------------------------------
											// 1. Inject CSS inside JS (once)
											// ------------------------------------------------------
											if (!document.getElementById("dt-dropdown-spinner-style")) {
												const style = document.createElement("style");
												style.id = "dt-dropdown-spinner-style";
												style.innerHTML = `
													.dt-dropdown-spinner {
														display: flex;
														justify-content: center;
														align-items: center;
														padding: 10px;
														font-size: 14px;
														font-weight: 500;
														color: #444;
														gap: 8px;
													}
													.dt-dropdown-spinner .loader {
														border: 3px solid #eee;
														border-top: 3px solid #3498db;
														border-radius: 50%;
														width: 16px;
														height: 16px;
														animation: spin 0.9s linear infinite;
													}
													@keyframes spin {
														0% { transform: rotate(0deg); }
														100% { transform: rotate(360deg); }
													}
												`;
												document.head.appendChild(style);
											}

											// ------------------------------------------------------
											// 2. Find the dropdown container
											// ------------------------------------------------------
											const dropdown = document.querySelector(".dt-button-collection");

											if (dropdown) {
												// Remove old spinner if exists
												const old = dropdown.querySelector(".dt-dropdown-spinner");
												if (old) old.remove();

												// Create spinner row
												const spinnerDiv = document.createElement("div");
												spinnerDiv.className = "dt-dropdown-spinner";
												spinnerDiv.innerHTML = `
													<div class="loader"></div>
													Generating PDF...
												`;

												// Insert spinner at TOP of dropdown menu
												const menu = dropdown.querySelector("[role='menu']");
												if (menu) {
													menu.prepend(spinnerDiv);
												}
											}

											// ------------------------------------------------------
											// 3. Your existing PDF logic
											// ------------------------------------------------------

											if (!window.incidentChart || !window.incidentChartData) {
												alert("Chart not loaded yet.");
												removeSpinner();
												return;
											}

											var chartImageUri = window.incidentChart.getImageURI();

											var legendData = window.incidentReports.map((item, idx) => ({
												incidentType: item.incidentType,
												count: item.count,
												color: window.incidentColors[idx % window.incidentColors.length]
											}));

											var table = $("#incidentTable").DataTable();
											var dateRangeValue = $("#incident_rangeDate").val();

											var tableData = table.rows({ search: "applied" }).data().toArray().map(row => ({
												dateRange: dateRangeValue || "",
												locationName: row.locationName || "",
												incidentType: row.incidentType || "",
												count: row.count || 0
											}));

											var payload = {
												chartImage: chartImageUri,
												legend: legendData,
												table: tableData
											};

											fetch("/action/generate-incident-pdf", {
												method: "POST",
												headers: { "Content-Type": "application/json" },
												body: JSON.stringify(payload)
											})
												.then(response => response.blob())
												.then(blob => {
													var url = window.URL.createObjectURL(blob);
													var a = document.createElement("a");
													a.href = url;
													a.download = "IncidentReport.pdf";
													document.body.appendChild(a);
													a.click();
													a.remove();
													window.URL.revokeObjectURL(url);
												})
												.catch(err => {
													console.error("PDF generation error:", err);
													alert("Failed to generate PDF.");
												})
												.finally(() => {
													removeSpinner();
												});


											// ------------------------------------------------------
											// 4. Remove spinner when done
											// ------------------------------------------------------
											function removeSpinner() {
												const dropdown = document.querySelector(".dt-button-collection");
												if (dropdown) {
													const spinner = dropdown.querySelector(".dt-dropdown-spinner");
													if (spinner) spinner.remove();
												}
											}
										}

									},
									{ extend: 'excelHtml5', text: 'Export to Excel' },
									{ extend: 'csvHtml5', text: 'Export to CSV' }
								]
							}
						]
					}
				},
				columns: [
					{
						className: 'details-control',
						orderable: false,
						data: null,
						defaultContent: '<span style="cursor:pointer;">&#x25B6;</span>', // arrow symbol
						title: '',
						width: '20px'
					},
					{
						data: null,
						title: 'Date Range',
						render: function () {
							return dateRange; // show the selected date range
						}
					},
					{ data: 'locationName', title: 'Location Name' },
					{ data: 'incidentType', title: 'Incident Type' },
					{
						data: 'count',
						title: 'Number of Reports',
						render: function (data) {
							return data + ' Reports';
						}
					},
					{ data: 'ids', visible: false }
				],
				initComplete: function (settings, json) {

					drawIncidentBarChart(json)
					// populateIncidentDropdown(json);
				},
				responsive: true,
				processing: true,
				serverSide: false,
				order: [[3, 'desc']],
				pageLength: 10,
				language: {
					emptyTable: "No incident reports found for selected date range."
				}
			});

			// Add .off() before .on() to remove duplicates
			$('#incidentTable tbody')
				.off('click', 'td.details-control')
				.on('click', 'td.details-control', function () {
					// ... all your existing code ...
					var tr = $(this).closest('tr');
					var row = $('#incidentTable').DataTable().row(tr);
					var cell = $(this);
					var ids = row.data().ids;

					if (row.child.isShown()) {
						// Close row
						row.child.hide();
						tr.removeClass('shown');
						cell.html('<span style="cursor:pointer;">&#x25B6;</span>'); // ▶
					} else {
						// Open row
						row.child('<div>Loading...</div>').show();
						tr.addClass('shown');
						cell.html('<span style="cursor:pointer;">&#x25BC;</span>'); // ▼

						// Fetch details via AJAX
						$.ajax({
							url: '/action/fetchIncidentDetails',
							type: 'GET',
							data: { ids: ids },
							success: function (detailsHtml) {
								row.child(detailsHtml).show();
							},
							error: function () {
								row.child('<div>Error loading details.</div>').show();
							}
						});
					}
				});


		});
	}

	function shiftReport() {
		ensureShiftTableHeaderLayout();
		if ($.fn.DataTable.isDataTable('#shiftTable')) {
			$('#shiftTable').DataTable().destroy();
			$('#shiftTable').empty(); // Remove old <thead> and <tbody>
		}
		google.charts.load('current', { 'packages': ['corechart'] });

		google.charts.setOnLoadCallback(function () {
			let dateRange = $('#shift_rangeDate').val();
			let locations = $('#shiftsList').val();
			let locationsStr = locations ? locations.join(',') : '';
			let type = $('#shift-type-dropdown').val(); // 0 = Person, 1 = Date

			// Destroy existing table if it exists
			if ($.fn.DataTable.isDataTable('#shiftTable')) {
				$('#shiftTable').DataTable().destroy();
			}

			if (!locationsStr) {
				$('#shiftTable').empty();
				return;
			}

			// Define columns dynamically based on type
			let tableColumns = type === "0"
				? [
					{ data: 'name', title: 'Name' },
					{ data: 'shiftDate', title: 'Shift Date' },
					{ data: 'startTime24h', title: 'Start Time' },
					{ data: 'endTime24h', title: 'End Time' },
					{
						data: 'durationHours',
						title: 'Duration (Hours)',
						render: function (data) {
							return data ? data.toFixed(2) : "0.00";
						}
					},
					{
						data: 'id',
						title: 'Actions',
						orderable: false,
						render: function (data) {
							return '<button class="view-logs-btn" data-shift-id="' + data + '" style="background: none; border: none; color: #0066cc; cursor: pointer; text-decoration: underline; padding: 0; font-size: 14px;">View Logs</button>';
						}
					}
				]
				: [
					{ data: 'name', title: 'Name' },
					{ data: 'logDate', title: 'Log Date' },
					{ data: 'logCount', title: 'Log Count' },
					{
						data: 'id',
						title: 'Actions',
						orderable: false,
						render: function (data) {
							return '<button class="view-logs-btn" data-shift-id="' + data + '" style="background: none; border: none; color: #0066cc; cursor: pointer; text-decoration: underline; padding: 0; font-size: 14px;">View Logs</button>';
						}
					}
				];

			let table = $('#shiftTable').DataTable({
				ajax: {
					url: '/action/fetchShiftAnalytics',
					type: 'GET',
					data: {
						dateRange: dateRange,
						locations: locationsStr,
						type: type
					},
					dataSrc: '',
					error: function () {
						alert('Failed to fetch data.');
					}
				},
				layout: {
					topStart: {
						buttons: [
							'pageLength',
							{
								extend: 'collection',
								text: 'Download',
								attr: {
									class: "dt-button buttons-collection dt-download-btn",
								},
								buttons: [
									{
										text: 'Export PDF',
										action: function (e, dt, button, config) {

											// ------------------------------------------------------
											// 1. Inject CSS once (if not already added)
											// ------------------------------------------------------
											if (!document.getElementById("dt-dropdown-spinner-style")) {
												const style = document.createElement("style");
												style.id = "dt-dropdown-spinner-style";
												style.innerHTML = `
												.dt-dropdown-spinner {
													display: flex;
													justify-content: center;
													align-items: center;
													padding: 10px;
													font-size: 14px;
													font-weight: 500;
													color: #444;
													gap: 8px;
												}
												.dt-dropdown-spinner .loader {
													border: 3px solid #eee;
													border-top: 3px solid #3498db;
													border-radius: 50%;
													width: 16px;
													height: 16px;
													animation: spin 0.9s linear infinite;
												}
												@keyframes spin {
													0% { transform: rotate(0deg); }
													100% { transform: rotate(360deg); }
												}
											`;
												document.head.appendChild(style);
											}

											// ------------------------------------------------------
											// 2. Insert the spinner INSIDE the dropdown
											// ------------------------------------------------------
											const dropdown = document.querySelector(".dt-button-collection");

											if (dropdown) {
												// Remove any existing spinner
												const old = dropdown.querySelector(".dt-dropdown-spinner");
												if (old) old.remove();

												const spinnerDiv = document.createElement("div");
												spinnerDiv.className = "dt-dropdown-spinner";
												spinnerDiv.innerHTML = `
													<div class="loader"></div>
													Generating Shift PDF...
												`;

												const menu = dropdown.querySelector("[role='menu']");
												if (menu) menu.prepend(spinnerDiv);
											}

											// ------------------------------------------------------
											// 3. Your original shift PDF generation logic
											// ------------------------------------------------------
											if (!window.shiftChart || !window.shiftChartData) {
												alert('Chart not loaded yet.');
												removeSpinner();
												return;
											}

											var chartImageUri = window.shiftChart.getImageURI();

											var table = $('#shiftTable').DataTable();
											var dateRangeValue = $('#shift_rangeDate').val();
											var tableData = table.rows({ search: 'applied' }).data().toArray();

											var payload = {
												chartImage: chartImageUri,
												type: window.shiftType,
												table: tableData,
												dateRange: dateRangeValue || ''
											};

											fetch('/action/generate-shift-pdf', {
												method: 'POST',
												headers: { 'Content-Type': 'application/json' },
												body: JSON.stringify(payload)
											})
												.then(response => response.blob())
												.then(blob => {
													var url = window.URL.createObjectURL(blob);
													var a = document.createElement('a');
													a.href = url;
													a.download = 'DailyShiftReport.pdf';
													document.body.appendChild(a);
													a.click();
													a.remove();
													window.URL.revokeObjectURL(url);
												})
												.catch(err => {
													console.error('PDF generation error:', err);
													alert('Failed to generate PDF.');
												})
												.finally(() => {
													removeSpinner();
												});

											// ------------------------------------------------------
											// 4. Remove spinner from dropdown
											// ------------------------------------------------------
											function removeSpinner() {
												const dropdown = document.querySelector(".dt-button-collection");
												if (!dropdown) return;

												const spinner = dropdown.querySelector(".dt-dropdown-spinner");
												if (spinner) spinner.remove();
											}
										}

									},
									{ extend: 'excelHtml5', text: 'Export to Excel' },
									{ extend: 'csvHtml5', text: 'Export to CSV' }
								]
							}
						]
					}
				},
				columns: tableColumns,
				initComplete: function (settings, json) {
					drawShiftBarChart(json, type); // unified chart
					// drawShiftLineChart(json, type);

					// No need to fetch log counts via AJAX; use logCount from backend for both filters

					// Handle View Logs button click
					$('#shiftTable tbody').on('click', 'button.view-logs-btn', function () {
						var shiftId = $(this).data('shift-id');
						var $btn = $(this);

						// Disable button and show loading state
						$btn.prop('disabled', true).text('Loading...');

						// Fetch shift logs by shiftId
						$.ajax({
							url: '/action/fetchShiftLogs',
							type: 'GET',
							data: { shiftId: shiftId },
							success: function (logsData) {
								// Restore button state
								$btn.prop('disabled', false).text('View Logs');

								// Populate modal with logs
								showLogsModal(shiftId, logsData);
							},
							error: function () {
								// Restore button state
								$btn.prop('disabled', false).text('View Logs');
								alert('Error loading logs.');
							}
						});
					});
				},
				responsive: true,
				order: [[1, 'desc']],
				pageLength: 10,
				language: { emptyTable: "No data available for selected filters." }
			});
		});

	}

	async function loadLogoAsBase64(callback) {
		var img = new Image();
		img.crossOrigin = "Anonymous"; // Handle cross-origin issues if the image is on a different domain
		img.src = "/static/assets/img/logo.png";
		img.onload = function () {
			var canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;
			var ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);
			var imgData = canvas.toDataURL("image/png");
			callback(imgData);
		};
	}

	$(document).on("click", "#analyticsSearchBtn", (e) => {
		$("#analyticsSearchBtn").addClass("btn-processing_active");
		setTimeout(function () { $("#analyticsSearchBtn").removeClass("btn-processing_active"); }, 2000);

		loadGraph();

	});

	function postReqV2(data, dataType, callback, errorCallback) {
		$.ajax({
			url: `/action/fetchChartDetails?dataType=${dataType}`,
			method: "post",
			data: JSON.stringify(data),
			contentType: "application/json; charset=utf-8",
			success: (res) => { callback(res) },
			error: () => { errorCallback(); }
		});
	}

	function postReq(data, dataType, callback, errorCallback) {
		$.ajax({
			url: `/action/fetchChartDetails?dataType=${dataType}`,
			method: "post",
			data,
			success: (res) => { callback(res) },
			error: () => { errorCallback(); }
		});
	}


	function loadGraph(ini = true) {
		if ($("#rangeDate").length &&
			$("#locIds").length &&
			$("#checklists").length &&
			$("#collect").length) {
			google.charts.load('current', { 'packages': ['corechart'] });
			google.charts.setOnLoadCallback(() => {
				const rangeDate = $("#rangeDate").val();
				const locations = $("#locIds").val();
				const checklists = $("#checklists").val().toString();
				const collect = $("#collect").val();

				if (ini) {
					localStorage.setItem("rangeDate", rangeDate);
					localStorage.setItem("locIds", locations);
					localStorage.setItem("checklists", checklists);
					localStorage.setItem("collect", collect);
				}

				var startDate = rangeDate ? moment(rangeDate.split(" - ")[0], dateFormat) : moment().subtract(6, 'days');
				var endDate = rangeDate ? moment(rangeDate.split(" - ")[1], dateFormat) : moment();

				endDate = endDate.format('YYYY-MM-DD');
				startDate = startDate.format('YYYY-MM-DD');
				const diffTime = Math.abs(new Date(endDate) - new Date(startDate));
				const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

				if (collect == "not_completed") {
					$("#completedNotCompleted").attr("report-title", "Not Completed checklist");
					$(".pie-chart-title").text("Not Completed checklist");
					$(".pie-chart-title-details").text("Not Completed checklist details");
				} else if (collect == "completed") {
					$("#completedNotCompleted").attr("report-title", "Completed checklist");
					$(".pie-chart-title").text("Completed checklist");
					$(".pie-chart-title-details").text("Completed checklist details");
				} else {
					$("#completedNotCompleted").attr("report-title", "Completed & Not Completed checklist");
					$(".pie-chart-title").text("Completed & Not Completed checklist");
					$(".pie-chart-title-details").text("Completed & Not Completed checklist details");
				}
				postReq({ locations, startDate, endDate, collect, checklists }, "barchart-count",
					function (response) {
						var res = response;
						res = res != undefined ? [res[0].deficiencies, res[0].pictures, res[0].nfcs_not_scanned] : [0, 0, 0];
						drawBarChart(res[0], res[1], res[2]);
					}, function () { drawBarChart(0, 0, 0); }
				);

				var checklistDetailsTableBody = $("#checklistDetailsTable tbody");
				var checklistDetailsTable = $("#checklistDetailsTable");
				if (DataTable.isDataTable(checklistDetailsTable))
					$(checklistDetailsTable).DataTable().clear().destroy();

				postReq({ locations, startDate, endDate, collect, checklists }, "barchart",
					function (data) {
						const dataUpdated = new Map();

						$.each(data, function (a, b) {
							const newData = b;
							if (dataUpdated.has(newData.id)) {
								let existingData = dataUpdated.get(newData.id);

								existingData.response_ids = newData.response_ids + existingData.response_ids;
								existingData.total_pictures += newData.total_pictures;
								existingData.total_deficiencies += newData.total_deficiencies;
								existingData.total_nfcs_not_scanned += newData.total_nfcs_not_scanned;
							} else dataUpdated.set(newData.id, newData);
						});

						const rangeDate = $("#rangeDate").val();

						$.each([...dataUpdated.values()], function (a, b) {
							var responses = b.response_ids != undefined ? b.response_ids : undefined;
							checklistDetailsTableBody.append("<tr data-json='" + JSON.stringify(b.json_d) + "'>" +
								"<td class='dt-control' table-id='checklistDetailsTable' data-checklist='" + b.checklist + "' data-id='" + (responses ? responses : 0) + "'>" + "</td>" +
								"<td>" + rangeDate + "</td>" +
								"<td>" + b.location_name + "</td>" +
								"<td>" + b.checklist + "</td>" +
								"<td>" + (b.total_deficiencies ? b.total_deficiencies : '0') + "</td>" +
								"<td>" + (b.total_pictures ? b.total_pictures : '0') + "</td>" +
								"<td>" + (b.total_nfcs_not_scanned ? b.total_nfcs_not_scanned : '0') + "</td></tr>");
						});

						var table = initializeDataTable(checklistDetailsTable);
						$('.dt-search>input[aria-controls="' + checklistDetailsTable.attr("id") + '"]')
							.off()
							.on('keyup', function (e) {
								filterByJson(this.value, table, $(e.currentTarget).attr("aria-controls"));
							})
					}, function () {
						var table = initializeDataTable(checklistDetailsTable);
						$('.dt-search>input[aria-controls="' + checklistDetailsTable.attr("id") + '"]')
							.off()
							.on('keyup', function (e) {
								filterByJson(this.value, table, $(e.currentTarget).attr("aria-controls"));
							})
					}
				);

				postReq({ locations, startDate, endDate, collect, checklists }, "checklist-count",
					function (response) {
						var res = response;
						res = res && res.length > 0 ? [res[0].sum, res[1].sum] : [0, 0];
						drawPieChart(res[0], res[1]);
					}, function () { drawPieChart(0, 0); }
				)

				var cNotCTableBody = $("#completedNotCompleted tbody");
				var cNotCTable = $("#completedNotCompleted");
				if (DataTable.isDataTable(cNotCTable))
					$(cNotCTable).DataTable().destroy();


				postReq({ locations, startDate, endDate, collect, checklists }, "checklist",
					function (data) {
						cNotCTableBody.empty();
						const rangeDate = $("#rangeDate").val();
						$.each(data, function (a, b) {
							var responses = b.response_ids != undefined ? b.response_ids : undefined;
							const submitDate = b.sub_time ? b.sub_time : 1;

							let reqDays = null; // Default value
							if (b.checklist.toLowerCase().includes("bi-annually") || b.checklist.toLowerCase().includes("bi-annuall")) {
								reqDays = 182; // Bi-annually
							} else if (b.checklist.toLowerCase().includes("annually") || b.checklist.toLowerCase().includes("annual")) {
								reqDays = 365; // Annually
							} else {
								reqDays = b.req_days; // Use the existing value if it's not bi-annual or annual
							}

							cNotCTableBody.append("<tr data-json='" + reqDays + "'><td table-id='completedNotCompleted' class='dt-control' data-submitdate='" + submitDate + "' data-checklist='" + b.checklist + "' data-id='" + (responses ? responses : 0) + "'>" + "</td>" +
								"<td>" + rangeDate + "</td>" +
								"<td class='sb-word-wrap-bw'>" + b.location_name + "</td>" +
								"<td>" + b.checklist + "</td>" +
								"<td>" + (b.completed > 0 ? responses.split(",").length + " Reports" : (b.not_completed + " Reports Not Completed")) + "</td></tr>");
						});

						var table = initializeDataTable(cNotCTable);
						$('.dt-search>input[aria-controls="' + cNotCTable.attr("id") + '"]')
							.off()
							.on('keyup', function (e) {
								filterByJson(this.value, table, $(e.currentTarget).attr("aria-controls"));
							})
					}, function () {
						var table = initializeDataTable(cNotCTable);
						$('.dt-search>input[aria-controls="' + cNotCTable.attr("id") + '"]')
							.off()
							.on('keyup', function (e) {
								filterByJson(this.value, table, $(e.currentTarget).attr("aria-controls"));
							})
					}
				)
			});
		}
	}

	function generateUniqueId() {
		// Using timestamp and a random number to ensure uniqueness
		return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1000); // Example format: id-1632482893452-123
	}

	$(document).on('click', 'td.dt-control', function (e) {
		let tr = $(e.target).closest('tr');
		var tableId = $(e.target).attr("table-id");
		var req_days = tr.attr("data-json");
		let row = $("#" + tableId).DataTable().row(tr);

		var locIds = $(e.target).attr("data-id");
		var checklist = $(e.target).attr("data-checklist");
		var expandTd = $(e.target).closest('td');

		// Create loader element (you can adjust the type of loader as needed)
		var loader = $("<div>").addClass("loader"); // Add the 'loader' class to style the loader
		var style = document.createElement('style');
		style.innerHTML = `
			@keyframes spin {
				0% { transform: rotate(0deg); }
				100% { transform: rotate(360deg); }
			}
			.loader {
				width: 20px; 
				height: 20px; 
				border: 4px solid #f3f3f3; 
				border-top: 4px solid #3498db; 
				border-radius: 50%; 
				animation: spin 1s linear infinite;
			}
		`;
		document.head.appendChild(style);

		expandTd.append(loader);

		if (row.child.isShown()) {
			row.child.hide();
			expandTd.find(".loader").remove();
		} else {
			var htmlStr =
				"<table class='sb-datatable sb-w100'>" +
				"<thead>" +
				"<tr>" +
				"<th>Submitted at</th>" +
				"<th>Submitted by</th>" +
				"<th></th>";

			if (tableId === "checklistDetailsTable")
				htmlStr += "<th>Deficiencies</th>" +
					"<th>Pictures</th>" +
					"<th>NFCs Not Scanned</th>";

			htmlStr += "</tr>" +
				"</thead>" +
				"<tbody>";

			if (locIds !== undefined && locIds.includes("not_completed")) {
				if (tableId == "completedNotCompleted") {
					const rangeDate = $("#rangeDate").val();

					var dataSubmitdate = $(e.target).attr("data-submitdate");
					var startDate = rangeDate ? moment(rangeDate.split(" - ")[0], dateFormat) : moment().subtract(6, 'days');
					var endDate = rangeDate ? moment(rangeDate.split(" - ")[1], dateFormat) : moment();

					endDate = endDate.format('YYYY-MM-DD');
					startDate = startDate.format('YYYY-MM-DD');

					const days = getDaysArray(startDate, endDate);

					utils.fetchGenDatas({ ids: locIds.split("-")[0] }, (data) => {
						// Sort the data based on dateField1
						data.sort(function (a, b) {
							return new Date(b.dateField1) - new Date(a.dateField1);
						});

						// Determine ranges based on req_days
						const getRanges = (start, end, req_days) => {
							let ranges = [];
							let current = moment(start);

							while (current.isBefore(end) || current.isSame(end)) {
								let rangeStart = current.clone();
								let rangeEnd;

								if (req_days === "1") {
									rangeEnd = rangeStart.clone(); // Daily
								} else if (req_days === "7") {
									rangeEnd = rangeStart.clone().endOf('week'); // Weekly (Sunday as the end of the week)
								} else if (req_days === "30") {
									rangeEnd = rangeStart.clone().endOf('month'); // Monthly
								} else if (req_days === "182") {
									rangeEnd = rangeStart.clone().add(6, 'months').endOf('month'); // Bi-annual
								} else if (req_days === "365") {
									rangeEnd = rangeStart.clone().endOf('year'); // Annual
								}

								if (rangeEnd.isAfter(end)) {
									rangeEnd = moment(end); // Ensure it doesn't exceed the end date
								}

								ranges.push({ start: rangeStart.format('YYYY-MM-DD'), end: rangeEnd.format('YYYY-MM-DD') });
								current = rangeEnd.clone().add(1, 'day'); // Move to the next range
							}

							return ranges;
						};

						const ranges = getRanges(startDate, endDate, req_days);

						// Process ranges
						ranges.forEach((range) => {
							let personName = "-";
							let isRangeMatched = false;

							// Check if any data matches dates within this range
							data.forEach((d) => {
								const dataDate = moment(d.dateField1, dateFormat);
								if (dataDate.isBetween(range.start, range.end, undefined, '[]')) {
									isRangeMatched = true; // Match found within this range
								}
							});

							// If no match found, add "No Response" row
							if (!isRangeMatched) {
								if (req_days === "1") {
									// Show a single day in the format '2024-12-01'
									htmlStr +=
										"<tr>" +
										"<td class='sb-w20'>" + moment(range.start, 'YYYY-MM-DD').format('MMMM Do, YYYY') + "</td>" +
										"<td>" + personName + "</td>" +
										"<td>No Response</td>" +
										"</tr>";
								} else {
									// For other req_days, show the range
									let formattedStartDate = moment(range.start, 'YYYY-MM-DD').format('MMMM Do, YYYY'); // E.g., 'December 1st, 2024'
									let formattedEndDate = moment(range.end, 'YYYY-MM-DD').format('MMMM Do, YYYY');   // E.g., 'December 7th, 2024'

									htmlStr +=
										"<tr>" +
										"<td class='sb-w20' style='white-space: nowrap; width: 200px;'>" + formattedStartDate + " - " + formattedEndDate + "</td>" +
										"<td>" + personName + "</td>" +
										"<td>No Response</td>" +
										"</tr>";
								}
							}
						});

						// Finish populating the table after processing ranges
						htmlStr +=
							"</tbody>" +
							"</table>";

						// Show the child row with the populated HTML
						row.child(htmlStr).show();
						$("#" + tableId).find(".sb-datatable").parent().addClass("sb-p0i");

						loader.remove();
					});

				} else {
					htmlStr += "<tr>" +
						"<td colspan='4'>No Records</td>" +
						"</tr>";
					htmlStr +=
						"</tbody>" +
						"</table>"
				}
			} else {
				utils.fetchGenDatas({ ids: locIds }, (data) => {
					var personIds = "";
					data.sort(function (a, b) {
						return new Date(b.dateField1) - new Date(a.dateField1);
					});

					$.each(data, function (i, b) {
						personIds += personIds == "" ? b.field6 : "," + b.field6;
						var formattedDate = moment(b.dateField1).format(dateFormat); // Change the format as needed
						b.dateField1 = formattedDate;
					});

					postReq({ personIds }, "checklist-persons",
						function (persons) {
							for (var ii = 0; data && ii < data.length; ii++) {
								var dO = data[ii];
								var personName = (persons ? persons[dO.field6].first_name + " " + persons[dO.field6].last_name : "-");
								var uniqueId = generateUniqueId();
								rowData[dO.id] = dO.field3;
								htmlStr +=
									"<tr class='response-details-updated-btn stool-shared-popup-btn' data-id='response-details' data-json='" + dO.id + "' data-submitter='" + personName + "' data-date='" + dO.dateField1 + "' data-checklist='" + checklist + "'>" +
									"<td class='sb-w20'>" + dO.dateField1 + "</td>" +
									"<td>" + personName + "</td>" +
									"<td class='sb-fw-bold-cblue'>View Response</td>";

								if (tableId == 'checklistDetailsTable') {

									let deficiencies = 0;
									let notNfcScanned = 0;
									let pictures = 0;

									var responseJson = JSON.parse(dO.field3);

									responseJson.questions.forEach((question) => {
										// Count deficiencies
										deficiencies += question.hasOwnProperty("deficiency") ? 1 : 0;

										// Count NFC not scanned
										notNfcScanned += question.hasOwnProperty("NFCValidated")
											? (question.NFCValidated === false ? 1 : 0)
											: 0;

										// Count pictures
										pictures += question.hasOwnProperty("picture") ? 1 : 0;
									});

									htmlStr +=
										"<td>" + deficiencies + "</td>" +
										"<td>" + pictures + "</td>" +
										"<td>" + notNfcScanned + "</td>";
								}

								htmlStr += "</tr>";
							}

							htmlStr +=
								"</tbody>" +
								"</table>";

							row.child(htmlStr).show();
							$("#" + tableId).find(".sb-datatable").parent().addClass("sb-p0i");

							loader.remove();
						}, function () { console.warn("error"); }
					)
				});
			}
		}
	});


	function process(show) {
		$('.site-overlay').toggleClass('site-overlay_processing', show);
	}

	function setQuestions(clone, questions) {
		let blocks = $('.response-details__blocks');
		let questionBlocks = questions.map(question => {
			return getQuestionBlock(clone, question);
		});

		blocks.find('.response-details-block:not(.response-details-block_clone)').remove();
		blocks.append(questionBlocks);
	}

	function isFormFieldAnswerEmpty(answer) {
		if (answer === null || answer === undefined) {
			return true;
		}
		if (typeof answer === 'string') {
			return answer.trim() === '';
		}
		if (Array.isArray(answer)) {
			return answer.length === 0 || answer.every(function (value) {
				return value === null || value === undefined || String(value).trim() === '';
			});
		}
		return false;
	}

	function setFormFieldAnswer($answerEl, answer) {
		if (isFormFieldAnswerEmpty(answer)) {
			$answerEl
				.text('No input given')
				.addClass('response-details-block__answer_empty');
			return;
		}

		$answerEl
			.text(answer)
			.removeClass('response-details-block__answer_empty');
	}

	function buildFormImageUrl(key) {
		const domain = window.location.hostname;
		const encoded = encodeURIComponent(key);
		return domain === "localhost"
			? `http://localhost:9006/public/interactive-form/images?key=${encoded}`
			: `${window.location.origin}/pdf-service/public/interactive-form/images?key=${encoded}`;
	}

	function setFormFields(clone, fields) {
		let blocks = $('.response-details__blocks');
		let fieldBlocks = (fields || []).map(function (field) {
			let newClone = clone.clone();
			$('.response-details-block__title', newClone).text(field.label || field.field || '');
			$('.response-details-block__description', newClone).text(
				field.type ? ('Type: ' + field.type) : ''
			);
			setFormFieldAnswer($('.response-details-block__answer', newClone), field.answer);
			$('.response-details-block__nfc', newClone).remove();
			$('.response-details-block__nfc-not-scanned', newClone).remove();
			$('.response-details-block__deficiency', newClone).remove();
			$('.response-details-block__pic', newClone).remove();
			$('.response-details-block__answer-time', newClone).remove();

			const images = Array.isArray(field.images)
				? field.images.filter(function (k) { return k && String(k).trim() !== ''; })
				: [];

			if (images.length) {
				createImagePopup();
				const urls = images.map(buildFormImageUrl);
				const $btn = $('.response-details-block__pic-btn', newClone);
				$btn.text('See Pictures (' + urls.length + ')')
					.off('click')
					.on('click', function () { showImagePopup(urls); });
			} else {
				$('.response-details-block__pic-btn', newClone).remove();
			}

			return newClone;
		});

		blocks.find('.response-details-block:not(.response-details-block_clone)').remove();
		blocks.append(fieldBlocks);
	}

	function getCachedRowData(rowId) {
		if (!rowId || typeof window.rowDataCache === "undefined") {
			return null;
		}

		let cached = window.rowDataCache[rowId];
		if (typeof cached === "string") {
			try {
				cached = JSON.parse(cached);
			} catch (e) {
				return null;
			}
		}

		return cached;
	}

	function sanitizeFilenamePart(value, fallback) {
		const s = (value == null ? "" : String(value)).trim();
		if (!s) {
			return fallback || "unknown";
		}
		return s
			.replace(/[\\/:*?"<>|]/g, "_")
			.replace(/\s+/g, "_")
			.replace(/_+/g, "_")
			.replace(/^_|_$/g, "");
	}

	function ordinalSuffixForFilename(day) {
		if (day >= 11 && day <= 13) {
			return "th";
		}
		switch (day % 10) {
			case 1: return "st";
			case 2: return "nd";
			case 3: return "rd";
			default: return "th";
		}
	}

	function formatTimestampForFilename(dateStr) {
		const parseDate = function (raw) {
			if (!raw) {
				return new Date();
			}
			const cleaned = String(raw).replace(/\b(\d{1,2})(st|nd|rd|th)\b/gi, "$1");
			const parsed = new Date(cleaned);
			return isNaN(parsed.getTime()) ? new Date() : parsed;
		};
		const d = parseDate(dateStr);
		const months = [
			"january", "february", "march", "april", "may", "june",
			"july", "august", "september", "october", "november", "december"
		];
		const day = d.getDate();
		const pad = function (n) {
			return n < 10 ? "0" + n : String(n);
		};
		return day + ordinalSuffixForFilename(day) + "_"
			+ months[d.getMonth()] + "_"
			+ d.getFullYear() + "_"
			+ pad(d.getHours()) + "_"
			+ pad(d.getMinutes());
	}

	function buildFormSubmissionPdfFilename(locationName, formName, submittedAt) {
		const loc = sanitizeFilenamePart(locationName, "location");
		const form = sanitizeFilenamePart(formName, "form");
		const ts = formatTimestampForFilename(submittedAt);
		return loc + "_" + form + "_" + ts + ".pdf";
	}

	function resolveResponseExportContext(button) {
		const rowId = button.dataset.rowId || "";
		const cached = getCachedRowData(rowId);
		const meta = (window.rowDataMetaCache && window.rowDataMetaCache[rowId]) || {};

		let viewType = button.dataset.viewType || meta.viewType || "";
		let formId = button.dataset.formId || meta.formId || "";
		let submissionId = button.dataset.submissionId || meta.submissionId || "";
		let locationName = button.dataset.locationName || meta.locationName || "";
		let formName = button.dataset.formName || meta.formName || "";
		let submittedAt = button.dataset.submittedAt || meta.submittedAt || "";

		if (cached && Array.isArray(cached.fields)) {
			viewType = "form";
			formId = formId || cached.formId || cached.form_id || "";
			submissionId = submissionId || cached.submissionId || cached.submission_id || "";
		}

		if (window.activeResponseDetailsExport && window.activeResponseDetailsExport.rowId === rowId) {
			viewType = window.activeResponseDetailsExport.viewType || viewType;
			formId = window.activeResponseDetailsExport.formId || formId;
			submissionId = window.activeResponseDetailsExport.submissionId || submissionId;
			locationName = window.activeResponseDetailsExport.locationName || locationName;
			formName = window.activeResponseDetailsExport.formName || formName;
			submittedAt = window.activeResponseDetailsExport.submittedAt || submittedAt;
		}

		return {
			rowId: rowId,
			viewType: viewType,
			formId: formId,
			submissionId: submissionId,
			locationName: locationName,
			formName: formName,
			submittedAt: submittedAt
		};
	}

	function formatDateStr(dateStr) {
		// Remove ordinal suffixes (st, nd, rd, th)
		const sanitizedDateStr = dateStr.replace(/\b(\d{1,2})(st|nd|rd|th)\b/, "$1");

		// Parse the cleaned date string
		const date = new Date(sanitizedDateStr);

		// Check if the date is valid
		if (isNaN(date.getTime())) {
			console.error("Invalid date format:", dateStr);
			return "Invalid Date";
		}

		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const day = ("0" + date.getDate()).slice(-2);
		const month = monthNames[date.getMonth()];
		const year = date.getFullYear();

		return `${month}${day}-${year}`;
	}

	function formatDate(date) {
		let day = date.getDate();
		let month = date.getMonth() + 1;
		let year = date.getFullYear();
		let hour = date.getHours();
		let meridiemHour = hour % 12 === 0 && hour === 12 ? 12 : hour % 12;
		let minute = date.getMinutes();
		let meridiem = hour >= 12 ? 'PM' : 'AM';

		// Pad minute with a leading zero if needed.
		minute = minute < 10 ? '0' + minute : minute;

		if (document.documentElement.lang === 'fr') {
			return `${day}/${month}/${year.toString().substring(2)} ${hour}:${minute}`;
		} else {
			return `${month}/${day}/${year.toString().substring(2)} ${meridiemHour}:${minute} ${meridiem}`;
		}
	}

	function toggleImageVisibility({ currentTarget }) {
		let ctn = $(currentTarget).closest('.response-details-block');
		let image = ctn.find('.response-details-block__pic');
		let visible = image.hasClass('response-details-block__pic_visible');

		image.toggleClass('response-details-block__pic_visible', !visible);
	}


	function getQuestionBlock(clone, question) {
		let newClone = clone.clone();
		let image = $('.response-details-block__pic', newClone);
		let title = $('.response-details-block__title', newClone);
		let description = $('.response-details-block__description', newClone);
		let responseParagraph = $('.response-details-block__response', newClone);
		let answer = $('.response-details-block__answer', newClone);
		let nfc = $('.response-details-block__nfc', newClone);
		let time = $('.response-details-block__answer-time', newClone);
		let btn = $('.response-details-block__pic-btn', newClone);
		let date = question.hasOwnProperty('date') ? isNaN(Number(question.date)) ? new Date(question.date) : new Date(Number(question.date)) : null;
		let formattedDate = date != null ? formatDate(date) : '';
		let response = question.response == "true" ? "Yes" : question.response == "false" ? "No" : question.response;
		let nfcAnswer = question.NFCValidation ? (question.NFCValidated ? "NFC Validated" : "NFC Not Validated") : "";
		let deficiency = $('.response-details-block__deficiency', newClone);

		if (question.hasOwnProperty('deficiency')) {
			newClone.addClass('response-details-block_deficiency');
			deficiency.text(question.deficiency);
		}

		let nfcNotScanned = $('.response-details-block__nfc-not-scanned', newClone);
		if (question.hasOwnProperty('NFCValidated') && question.NFCValidated === false) {
			if (!question.hasOwnProperty('deficiency')) {
				newClone.addClass('response-details-block_nfc-not-scanned');
			}
			nfcNotScanned.text("NFC Not Scanned: " + (question.nfcReason && question.nfcReason != undefined ? question.nfcReason : "-"));
			nfcNotScanned.addClass("d-block");
		}

		answer.text(response);
		nfc.text(nfcAnswer);
		title.text(question.name);
		time.text(formattedDate);
		description.text(question.description);

		if (question.hasOwnProperty('picture')) {
			image.attr('src', `/action/sbHandleFile?id=${question.picture}`);
			image.hide(); // start hidden

			btn.off('click').on('click', function () {
				image.toggle();
				$(this).text(image.is(':visible') ? 'Hide picture' : 'See picture');
			});
		} else {
			image.remove();
			btn.remove();
		}

		return newClone;
	}


	const getDaysArray = function (start, end) {
		const arr = [];
		// Set the start date to midnight
		const startDate = new Date(start);
		startDate.setHours(0, 0, 0, 0);

		// Set the end date to midnight of the next day
		const endDate = new Date(end);
		endDate.setHours(0, 0, 0, 0);
		endDate.setDate(endDate.getDate() + 1); // Move to the next day to include the end date

		for (const dt = startDate; dt < endDate; dt.setDate(dt.getDate() + 1)) {
			arr.push(new Date(dt));
		}
		return arr;
	};

	function populateShiftDetails({ currentTarget }) {
		process(true);
		let ele = $(currentTarget);

		let logId = ele.attr("data-json") || "";
		let inTime = ele.attr("data-in") || "-";
		let outTime = ele.attr("data-out") || "-";
		let createdBy = ele.attr("data-createdby") || "-";
		let description = ele.attr("data-description") || "-";
		let type = ele.attr("data-type") || "-";
		let picture = ele.attr("data-picture");

		// Fill top info
		$(".shift-details").find(".shift-details__info").eq(0).html(`<span>In Time: </span>${inTime}`);
		$(".shift-details").find(".shift-details__info").eq(1).html(`<span>Out Time: </span>${outTime}`);
		$(".shift-details").find(".shift-details__info").eq(2).html(`<span>Created by: </span>${createdBy}`);

		// === Build card structure like incident ===
		const $block = $('<div class="incident-details__block incident-details-block"></div>');

		// Title
		const $title = $('<p class="incident-details-block__title">Shift Details</p>');

		// Description container
		const $desc = $('<p class="incident-details-block__description"></p>');

		function addRow(label, value) {
			const row = $(`
            <div class="incident-details-block__row">
                <span class="incident-details-block__label">${label}:</span>
                <span class="incident-details-block__value">${value}</span>
            </div>
        `);
			$desc.append(row);
		}

		// Add rows
		addRow("Type", type);
		addRow("Description", description);

		// Picture button (like incident)
		if (picture) {
			createImagePopup();
			const $btn = $('<button class="response-details-block__pic-btn sb-fw-bold-cblue">See Pictures</button>');
			$btn.on("click", function () {
				showImagePopup([picture]);
			});

			const $btnWrapper = $('<div class="incident-details-block__pic-btn-wrapper"></div>').css({
				display: "flex",
				justifyContent: "flex-end",
				marginTop: "10px"
			});

			$btnWrapper.append($btn);
			$desc.append($btnWrapper);
		}

		// Assemble block
		$block.append($title).append($desc).append('<div class="incident-details-block__extra"></div>');

		// Clear old blocks and insert new one
		$(".shift-details__blocks").empty().append($block);

		const button = document.querySelector(".shift-details__print");
		button.dataset.rowId = logId;

		process(false);
	}

	// Show logs modal with all shift logs as cards
	function showLogsModal(shiftId, logsData) {
		// Update modal title
		$(".shift-details__title").text('Shift Logs');

		const downloadButton = document.querySelector(".shift-details__print");
		if (downloadButton) {
			downloadButton.dataset.rowId = shiftId;
		}

		// Clear info fields
		$(".shift-details").find(".shift-details__info").eq(0).html('<span>Shift ID: </span>' + shiftId);
		$(".shift-details").find(".shift-details__info").eq(1).html('');
		$(".shift-details").find(".shift-details__info").eq(2).html('');

		// Create cards for each log
		const $blocksContainer = $(".shift-details__blocks").empty();

		// Check if logsData is HTML or JSON
		let logs = [];

		if (typeof logsData === 'string') {
			// Try to parse as JSON first
			try {
				logs = JSON.parse(logsData);
			} catch (e) {
				// If not JSON, treat as HTML and parse it
				const $html = $(logsData);

				// Check if it contains table rows with data attributes
				$html.find('tr').each(function () {
					const $row = $(this);

					// Helper function to get cell text, excluding button text
					function getCellText(cellIndex) {
						const $cell = $row.find('td').eq(cellIndex);
						let text = $cell.clone().find('button').remove().end().text().trim();
						return text || $cell.text().trim();
					}

					const log = {
						type: $row.attr('data-type') || getCellText(0),
						datetime: $row.attr('data-datetime') || $row.attr('data-timestamp') || getCellText(1),
						description: $row.attr('data-description') || getCellText(2),
						createdBy: $row.attr('data-createdby') || $row.find('td').eq(0).attr('data-createdby') || '',
						picture: $row.attr('data-picture')
					};
					// Only add if it has at least one non-empty field
					if (log.type || log.description || log.datetime || log.createdBy) {
						logs.push(log);
					}
				});

				// If no table rows found, try to parse as divs with data attributes
				if (logs.length === 0) {
					$html.find('[data-type]').each(function () {
						const $elem = $(this);
						const log = {
							type: $elem.attr('data-type'),
							description: $elem.attr('data-description'),
							datetime: $elem.attr('data-datetime') || $elem.attr('data-timestamp'),
							createdBy: $elem.attr('data-createdby'),
							picture: $elem.attr('data-picture')
						};
						logs.push(log);
					});
				}
			}
		} else if (Array.isArray(logsData)) {
			logs = logsData;
		}

		if (logs.length > 0) {
			logs.forEach(function (log) {
				const $block = $('<div class="incident-details__block incident-details-block"></div>');
				const $title = $('<p class="incident-details-block__title">Log Entry</p>');
				const $desc = $('<p class="incident-details-block__description"></p>');

				function addRow(label, value) {
					if (!value) return;
					const row = $(`
					<div class="incident-details-block__row">
						<span class="incident-details-block__label">${label}:</span>
						<span class="incident-details-block__value">${value}</span>
					</div>
				`);
					$desc.append(row);
				}

				// Add log fields as rows
				addRow("Type", log.type);
				addRow("Description", log.description);
				addRow("Datetime", log.datetime);
				addRow("Created By", log.createdBy);

				if (log.picture) {
					createImagePopup();
					const $btn = $('<button class="response-details-block__pic-btn sb-fw-bold-cblue">See Picture</button>');
					$btn.on("click", function () {
						showImagePopup([log.picture]);
					});
					const $btnWrapper = $('<div class="incident-details-block__pic-btn-wrapper"></div>').css({
						display: "flex",
						justifyContent: "flex-end",
						marginTop: "10px"
					});
					$btnWrapper.append($btn);
					$desc.append($btnWrapper);
				}

				// Assemble block
				$block.append($title).append($desc).append('<div class="incident-details-block__extra"></div>');
				$blocksContainer.append($block);
			});
		} else {
			$blocksContainer.html('<p style="padding: 20px; text-align: center;">No logs found</p>');
		}

		// Show the modal
		shiftDetailsPopup.addClass('visible');
	}

	// Create popup dynamically (only once)
	function createImagePopup() {
		if ($('#imagePopup').length > 0) return; // already exists

		const popupHtml = `
		<div id="imagePopup" class="image-popup" style="display:none;">
			<div class="image-popup-content">
				<span class="image-popup-close">&times;</span>
				<div id="imagePopupContainer" class="image-popup-container"></div>
			</div>
		</div>
	`;

		$('body').append(popupHtml);

		// Add CSS dynamically
		const styles = `
		.image-popup {
			position: fixed;
			top: 0; left: 0;
			width: 100%; height: 100%;
			background: rgba(0,0,0,0.7);
			display: flex; justify-content: center; align-items: center;
			z-index: 9999;
		}
		.image-popup-content {
			background: #fff;
			padding: 15px;
			border-radius: 10px;
			width: 500px;          /* not full width */
			max-width: 90%;
			max-height: 85%;
			overflow-y: auto;
			position: relative;
			box-shadow: 0 4px 20px rgba(0,0,0,0.3);
		}
		.image-popup-container {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.image-popup-container img {
			max-width: 100%;
			margin: 10px 0;
			border-radius: 6px;
			display: none; /* hide until loaded */
		}
		.image-popup-loader {
			border: 4px solid #f3f3f3;
			border-top: 4px solid #3498db;
			border-radius: 50%;
			width: 40px; height: 40px;
			animation: spin 1s linear infinite;
			margin: 20px auto;
		}
		@keyframes spin {
			0% { transform: rotate(0deg); }
			100% { transform: rotate(360deg); }
		}
		.image-popup-close {
			position: absolute;
			top: 10px; right: 20px;
			font-size: 30px;
			font-weight: bold;
			color: #333;
			cursor: pointer;
		}
	`;
		$('<style>').text(styles).appendTo('head');

		// Close handler
		$(document).on('click', '.image-popup-close', function () {
			$('#imagePopup').hide();
		});
	}
	function showImagePopup(photoIds) {
		const $popup = $('#imagePopup');
		const $container = $('#imagePopupContainer');

		$container.empty();

		photoIds.forEach(id => {
			const wrapper = $('<div style="width:100%; text-align:center;"></div>');
			const loader = $('<div class="image-popup-loader"></div>');
			const src = (typeof id === 'string' && (id.charAt(0) === '/' || id.indexOf('http') === 0))
				? id
				: `/action/sbHandleFile?id=${id}`;
			const img = $('<img>').attr('src', src);

			// Show loader until image loads
			img.on('load', function () {
				loader.remove();
				img.fadeIn();
			});

			wrapper.append(loader).append(img);
			$container.append(wrapper);
		});

		$popup.show();
	}


	// - process(boolean)
	// - rowData (your existing analytics data structure)
	// - setQuestions(clone, questionsData)
	// - window.rowDataCache (initialized in ai-search.js)

	function populateDetails({ currentTarget }) {
		process(true);
		let ele = $(currentTarget);
		let rowEle = ele.closest("tr").length ? ele.closest("tr") : ele;

		let date = rowEle.attr("data-date") || ele.attr("data-date");
		let locationName = rowEle.attr("data-location") || ele.attr("data-location") || "";
		// This variable now holds EITHER a numeric ID (old) OR a DYN_ prefixed index (new)
		let jsonId = rowEle.attr("data-json") || ele.attr("data-json");
		let submitter = rowEle.attr("data-submitter") || ele.attr("data-submitter");
		let checklist = rowEle.attr("data-checklist") || ele.attr("data-checklist");

		let rawData;
		let jsonData;

		// ====================================================================
		// 1. CONDITIONAL DATA RETRIEVAL LOGIC
		// ====================================================================

		// Check if jsonId is a key in the new cache (starts with 'DYN_')
		if (jsonId && jsonId.startsWith('DYN_')) {
			// New Row: Fetch the already stored (string or object) data from the global cache
			rawData = window.rowDataCache[jsonId];
		}
		// Fallback to the existing global rowData array lookup (for old analytics rows)
		else if (jsonId && typeof rowData !== 'undefined' && rowData[jsonId]) {
			rawData = rowData[jsonId];
		} else {
			// Data not found in either source
			console.error("Error: Response data not found for JSON ID:", jsonId);
			process(false);
			return;
		}

		// ====================================================================
		// 2. DATA PARSING
		// ====================================================================

		// Ensure the raw data is parsed into a JavaScript object if it's a string
		jsonData = rawData;
		if (typeof rawData === 'string') {
			try {
				jsonData = JSON.parse(rawData);
			} catch (e) {
				console.error("Error: Failed to parse JSON data:", e);
				process(false);
				return;
			}
		}

		// ====================================================================
		// 3. MODAL POPULATION (Your existing logic using the retrieved jsonData)
		// ====================================================================

		let clone = $('.response-details-block_clone').clone().removeClass('response-details-block_clone');
		let time = $('.response-details').find('.response-details__info').eq(0);
		let author = $('.response-details').find('.response-details__info').eq(1);

		const isFormView = rowEle.attr("data-view-type") === "form"
			|| ele.attr("data-view-type") === "form"
			|| (jsonData && Array.isArray(jsonData.fields));

		if (isFormView) {
			$(".response-details__title").text("Form submission");
			$(".response-details__checklist-title").html(checklist || "");
			time.html("<span>Submitted on: </span>" + date);
			author.html("<span>Submitted by: </span>" + submitter);
		} else {
			$(".response-details__title").text("Response");
			$(".response-details__checklist-title").html(checklist);
			time.html("<span>Completed on: </span>" + date);
			author.html("<span>Completed by: </span>" + submitter);
		}

		$(document.body).addClass('response-details-print');

		if (isFormView && jsonData && jsonData.fields) {
			setFormFields(clone, jsonData.fields);
		} else if (jsonData && jsonData.questions) {
			setQuestions(clone, jsonData.questions);
		} else {
			console.warn("JSON data is missing questions/fields:", jsonData);
			clone.html('<p class="text-red-500 p-4">Could not load submission details.</p>');
		}

		const button = document.querySelector(".response-details__print");
		button.dataset.rowId = jsonId; // Keep the original ID/Index (DYN_ or numeric) for print action

		const rowMeta = (window.rowDataMetaCache && window.rowDataMetaCache[jsonId]) || {};
		if (!locationName && rowMeta.locationName) {
			locationName = rowMeta.locationName;
		}
		if (!checklist && rowMeta.formName) {
			checklist = rowMeta.formName;
		}
		if (!date && rowMeta.submittedAt) {
			date = rowMeta.submittedAt;
		}
		const exportFormId = (jsonData && (jsonData.formId || jsonData.form_id))
			|| rowEle.attr("data-form-id")
			|| ele.attr("data-form-id")
			|| rowMeta.formId
			|| "";
		const exportSubmissionId = (jsonData && (jsonData.submissionId || jsonData.submission_id))
			|| rowEle.attr("data-submission-id")
			|| ele.attr("data-submission-id")
			|| rowMeta.submissionId
			|| "";

		if (isFormView) {
			button.dataset.viewType = "form";
			button.dataset.formId = exportFormId;
			button.dataset.submissionId = exportSubmissionId;
			button.dataset.locationName = locationName || "";
			button.dataset.formName = checklist || "";
			button.dataset.submittedAt = date || "";
			window.activeResponseDetailsExport = {
				rowId: jsonId,
				viewType: "form",
				formId: exportFormId,
				submissionId: exportSubmissionId,
				locationName: locationName || "",
				formName: checklist || "",
				submittedAt: date || ""
			};
		} else {
			button.removeAttribute("data-view-type");
			button.removeAttribute("data-form-id");
			button.removeAttribute("data-submission-id");
			window.activeResponseDetailsExport = {
				rowId: jsonId,
				viewType: "checklist",
				formId: "",
				submissionId: ""
			};
		}

		process(false);
	}

	var initializeISelectMultiple = function (select, field, viewField, prefix, postfix, jsonData) {
		if (!select) {
			console.warn("initializeISelectMultiple: select element not found");
			return;
		}
		const $select = $(select);
		$select.empty();

		const items = parseTreeSelectChecklistItems(jsonData);
		items.forEach(function (item) {
			const option = document.createElement("option");
			option.value = item.id;
			option.textContent = item.name;
			option.setAttribute("data-section", item.group);
			$select.append(option);
		});

		// Determine initial selection from existing hidden field value.
		// Do NOT auto-select all on page load; user must explicitly pick items.
		var initialIds = [];
		if (field) {
			var fv = $(field).val();
			if (fv && fv !== "all") {
				initialIds = fv.split(",").map(s => s.trim()).filter(Boolean);
			}
		}

		initManagerTree({
			select: select,
			field: field,
			viewField: viewField,
			prefix: prefix,
			postfix: postfix,
			data: items,
			grouped: true,
			preselected: initialIds,
			onChange: function () {
				if (typeof populateUsersOnLocations === "function") populateUsersOnLocations(field);
			}
		});

		populateUsersOnLocations(field);

		if ($("#rangeDate").length) {
			loadDataUsingParams('#rangeDate', loadGraph);
		}
	};

	var initializeISelectMultipleForIncidentAndShift = function (select, field, viewField, prefix, postfix, jsonData, callback) {
		if (!select) {
			console.warn("initializeISelectMultipleForIncidentAndShift: select element not found");
			if (typeof callback === "function") callback();
			return;
		}
		const $select = $(select);
		$select.empty();

		const items = parseTreeSelectLocationItems(jsonData);
		items.forEach(function (item) {
			const option = document.createElement("option");
			option.value = item.id;
			option.textContent = item.name;
			$select.append(option);
		});

		// Do NOT auto-select all on page load. Honor existing hidden field value if any.
		var initialIds = [];
		if (field) {
			var fv = $(field).val();
			if (fv && fv !== "all") {
				initialIds = fv.split(",").map(s => s.trim()).filter(Boolean);
			}
		}

		initManagerTree({
			select: select,
			field: field,
			viewField: viewField,
			prefix: prefix,
			postfix: postfix,
			data: items,
			grouped: false,
			preselected: initialIds
		});

		if (typeof callback === "function") callback();
	};

	// CSP-safe visibility toggles (style-src nonce blocks jQuery .hide/.show/.toggle)
	function treeSetVisible($el, visible) {
		$el.toggleClass("is-hidden", !visible);
	}

	function treeSetCollapsed($el, collapsed) {
		$el.toggleClass("is-collapsed", collapsed);
	}

	function parseTreeSelectChecklistItems(jsonData) {
		const items = [];
		if (!Array.isArray(jsonData)) return items;
		jsonData.forEach(function (group) {
			if (!group || !group.location) return;
			const locationName = (group.location.field2 || group.location.name || group.location.locationName || "").trim() || "Unknown";
			const checklists = group.checklist || group.checklists || [];
			checklists.forEach(function (item) {
				if (!item) return;
				const rawId = item.genDataId != null ? item.genDataId : item.id;
				if (rawId == null) return;
				const id = String(rawId);
				const name = (item.field2 || item.name || "").trim();
				if (!name) return;
				items.push({ id: id, name: name, group: locationName });
			});
		});
		return items;
	}

	function parseTreeSelectLocationItems(jsonData) {
		const items = [];
		if (!Array.isArray(jsonData)) return items;
		jsonData.forEach(function (group) {
			if (!group || !group.location) return;
			const locationName = (group.location.field2 || group.location.name || group.location.locationName || "").trim();
			const rawId = group.location.genDataId != null ? group.location.genDataId : group.location.id;
			if (rawId == null) return;
			items.push({ id: String(rawId), name: locationName || "Unknown", group: null });
		});
		return items;
	}

	// Custom tree-multiselect implementation (replaces jquery.tree-multiselect plugin)
	function ensureManagerTreeContainer($select, grouped) {
		const containerId = $select.attr("id") + "-tree";
		let $container = $("#" + containerId);
		if ($container.length) return $container;

		// Fallback when deployed XSL is older than dashboard.js (select exists, tree div missing)
		const groupedAttr = grouped ? ' data-grouped="true"' : ' data-grouped="false"';
		$container = $(
			'<div class="manager-tree tree-container" id="' + containerId + '"' + groupedAttr + '>' +
				'<div class="tree-left">' +
					'<input class="tree-search" placeholder="Search..." type="text" />' +
					'<div class="tree-toolbar">' +
						'<span class="tree-select-all">Select All</span>' +
						'<span class="tree-unselect-all">Unselect All</span>' +
					'</div>' +
					'<div class="tree-list"></div>' +
				'</div>' +
				'<div class="tree-right">' +
					'<div class="tree-selected"></div>' +
				'</div>' +
			'</div>'
		);
		$select.after($container);
		console.info("initManagerTree: created missing #" + containerId + " — redeploy manager.xsl to fix at source");
		return $container;
	}

	function initManagerTree(config) {
		const $select = $(config.select);
		if (!$select.length) {
			console.warn("initManagerTree: select element not found");
			return;
		}
		const $container = ensureManagerTreeContainer($select, !!config.grouped);

		const $treeList = $container.find(".tree-list");
		const $treeSelected = $container.find(".tree-selected");
		const $treeSearch = $container.find(".tree-search");
		const $selectAllBtn = $container.find(".tree-select-all");
		const $unselectAllBtn = $container.find(".tree-unselect-all");

		const selectedItems = new Set((config.preselected || []).map(String));
		const treeData = config.data || [];

		function syncHiddenSelect() {
			$select.find("option").each(function () {
				const sel = selectedItems.has(String(this.value));
				this.selected = sel;
				if (sel) $(this).attr("selected", "selected");
				else $(this).removeAttr("selected");
			});
		}

		function emitChange() {
			syncHiddenSelect();
			const ids = Array.from(selectedItems);
			if (config.field) $(config.field).val(ids.join(","));
			if (config.viewField) $(config.viewField).val((config.prefix || "") + selectedItems.size + (config.postfix || ""));
			if (typeof config.onChange === "function") config.onChange(ids);
		}

		function updateGroupCheckbox($groupChk, groupItems) {
			let checkedCount = 0;
			groupItems.forEach(it => { if (selectedItems.has(it.id)) checkedCount++; });
			if (checkedCount === 0) {
				$groupChk.prop("indeterminate", false).prop("checked", false);
			} else if (checkedCount === groupItems.length) {
				$groupChk.prop("indeterminate", false).prop("checked", true);
			} else {
				$groupChk.prop("indeterminate", true).prop("checked", false);
			}
		}

		function renderSelected() {
			$treeSelected.empty();
			treeData.forEach(item => {
				if (!selectedItems.has(item.id)) return;
				const $pill = $('<div class="selected-pill"></div>');
				const $text = $('<span class="pill-name"></span>').text(item.name);
				const $remove = $('<span class="remove">✕</span>');
				$remove.on("click", function () {
					selectedItems.delete(item.id);
					renderTree();
					renderSelected();
					emitChange();
				});
				$pill.append($text).append($remove);
				$treeSelected.append($pill);
			});
		}

		function renderTree() {
			$treeList.empty();

			if (!treeData.length) {
				$treeList.append('<div class="tree-empty-msg">No locations or checklists available.</div>');
				return;
			}

			if (config.grouped) {
				const groupMap = {};
				const groupOrder = [];
				treeData.forEach(item => {
					const g = item.group || "";
					if (!groupMap[g]) { groupMap[g] = []; groupOrder.push(g); }
					groupMap[g].push(item);
				});

				groupOrder.forEach(groupName => {
					const groupItems = groupMap[groupName];
					const $groupDiv = $('<div class="tree-group"></div>');
					const $collapseBtn = $('<span class="tree-collapse">−</span>');
					const $groupChk = $('<input type="checkbox" class="tree-group-check" />');
					const $groupLabel = $('<span class="tree-group-label"></span>').text(groupName);
					$groupDiv.append($collapseBtn).append($groupChk).append($groupLabel);
					const $itemsDiv = $('<div class="tree-items"></div>');

					groupItems.forEach(item => {
						const $itemDiv = $('<div class="tree-item"></div>')
							.attr("data-search", (item.name + " " + groupName).toLowerCase());
						const $chk = $('<input type="checkbox" class="tree-item-check" />')
							.val(item.id)
							.prop("checked", selectedItems.has(item.id));
						const $lbl = $('<span class="tree-item-label"></span>').text(item.name);
						$chk.on("change", function () {
							if (this.checked) selectedItems.add(item.id);
							else selectedItems.delete(item.id);
							updateGroupCheckbox($groupChk, groupItems);
							renderSelected();
							emitChange();
						});
						$lbl.on("click", function () { $chk.trigger("click"); });
						$itemDiv.append($chk).append($lbl);
						$itemsDiv.append($itemDiv);
					});

					$groupChk.on("change", function () {
						const checked = this.checked;
						groupItems.forEach(it => {
							if (checked) selectedItems.add(it.id);
							else selectedItems.delete(it.id);
						});
						renderTree();
						renderSelected();
						emitChange();
					});

					$groupLabel.on("click", function () { $groupChk.trigger("click"); });

					$collapseBtn.on("click", function (e) {
						e.stopPropagation();
						const $btn = $(this);
						if (!$itemsDiv.hasClass("is-collapsed")) {
							treeSetCollapsed($itemsDiv, true);
							$btn.text("+");
						} else {
							treeSetCollapsed($itemsDiv, false);
							$btn.text("−");
						}
					});

					$treeList.append($groupDiv).append($itemsDiv);
					updateGroupCheckbox($groupChk, groupItems);
				});
			} else {
				treeData.forEach(item => {
					const $itemDiv = $('<div class="tree-item tree-item-flat"></div>')
						.attr("data-search", item.name.toLowerCase());
					const $chk = $('<input type="checkbox" class="tree-item-check" />')
						.val(item.id)
						.prop("checked", selectedItems.has(item.id));
					const $lbl = $('<span class="tree-item-label"></span>').text(item.name);
					$chk.on("change", function () {
						if (this.checked) selectedItems.add(item.id);
						else selectedItems.delete(item.id);
						renderSelected();
						emitChange();
					});
					$lbl.on("click", function () { $chk.trigger("click"); });
					$itemDiv.append($chk).append($lbl);
					$treeList.append($itemDiv);
				});
			}
		}

		$treeSearch.off("input.tree").on("input.tree", function () {
			const term = String($(this).val() || "").toLowerCase().trim();
			$container.find(".tree-item").each(function () {
				const txt = $(this).attr("data-search") || "";
				treeSetVisible($(this), !term || txt.indexOf(term) !== -1);
			});
			// Hide empty groups
			$container.find(".tree-group").each(function () {
				const $group = $(this);
				const $next = $group.next(".tree-items");
				const anyVisible = $next.find(".tree-item:not(.is-hidden)").length > 0;
				if (term && !anyVisible) {
					treeSetVisible($group, false);
					treeSetVisible($next, false);
				} else {
					treeSetVisible($group, true);
					treeSetVisible($next, true);
				}
			});
		});

		$selectAllBtn.off("click.tree").on("click.tree", function () {
			treeData.forEach(it => selectedItems.add(it.id));
			renderTree();
			renderSelected();
			emitChange();
		});

		$unselectAllBtn.off("click.tree").on("click.tree", function () {
			selectedItems.clear();
			renderTree();
			renderSelected();
			emitChange();
		});

		renderTree();
		renderSelected();
		emitChange();
	}

	function applyTreeSelectData(data) {
		window.__treeSelectData = data;
		const checklistsList1 = document.querySelector("#checklistsList1");
		const checklistsList2 = document.querySelector("#checklistsList2");
		const incidentsList = document.querySelector("#incidentsList");
		const shiftsList = document.querySelector("#shiftsList");

		if (checklistsList1) {
			initializeISelectMultiple(checklistsList1, "#checklists", "#checklists-text", "(", ") selected", data);
		}
		if (checklistsList2) {
			initializeISelectMultiple(checklistsList2, "#rChecklists", null, "(", ") selected", data);
		}
		if (incidentsList) {
			initializeISelectMultipleForIncidentAndShift(incidentsList, "#rIncidents", "#incidents-text", "(", ") selected", data, incidentReport);
		}
		if (shiftsList) {
			initializeISelectMultipleForIncidentAndShift(shiftsList, "#rshifts", "#shifts-text", "(", ") selected", data, shiftReport);
		}
	}

	function populateUsersOnLocations(field) {
		if (field === "#rChecklists") {
			var checkedLabels = [];

			// Read group labels from the new custom tree (manager-tree)
			$("#checklistsList2-tree .tree-group").each(function () {
				var $chk = $(this).find("input.tree-group-check");
				if ($chk.is(":checked") || $chk.prop("indeterminate")) {
					checkedLabels.push($.trim($(this).find(".tree-group-label").text()));
				}
			});

			// Create a comma-separated string from the checked labels.
			var checkedString = checkedLabels.join(',');

			$.ajax({
				url: '/action/sbReminderUsers',
				type: 'POST',
				data: { Locations: checkedString },
				success: function (response) {

					var isMultiple = checkedString.indexOf(',') !== -1;
					var heading;

					if (document.documentElement.lang === 'fr') {
						heading = "Utilisateurs de l'emplacement" + (isMultiple ? "s" : "");
					} else {
						heading = (isMultiple ? "Locations" : "Location") + " Users";
					}

					var headingHtml = '<p><strong>' + heading + '</strong></p>';



					// If the response is empty ("" or empty array), display only the heading.
					if (!response || (response.length === 0 || !Array.isArray(response))) {
						$('#response-forward__persons').html(headingHtml);
						return;
					}

					// Sort the response array by full_name (alphabetically, case-insensitive)
					response.sort(function (a, b) {
						var nameA = a.full_name.toUpperCase();
						var nameB = b.full_name.toUpperCase();
						if (nameA < nameB) return -1;
						if (nameA > nameB) return 1;
						return 0;
					});

					// Start building the HTML output.
					var html = headingHtml;

					// Iterate through each user in the sorted response.
					$.each(response, function (index, user) {
						html += '<label class="form-checkbox-ctn response-forward__person" style="display:block; margin-bottom:10px;">';

						// Add the toggle button as the very first element.
						html += '<span class="toggle-arrow" style="cursor:pointer; background:#777; color:#fff; padding:2px 5px; display:inline-block; margin-right:5px;">+</span>';

						// Build the checkbox input.
						html += '<input type="checkbox" class="form-check-input response-forward__person-check reminder-field" ' +
							'name="response-forward-person" ' +
							'data-field1="' + user.person_id + '" ' +
							'data-field2="' + user.email + '" ' +
							'value="' + user.email + ' - ' + user.locations + '">';

						// Add the span for the checkbox graphic (using your SVG).
						html += '<span class="form-checkbox" style="vertical-align:middle; margin-left:5px;">';
						html += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="33.65px" height="25.86px" viewBox="0 0 33.65 25.86" xml:space="preserve">';
						html += '<polyline fill="none" stroke="#000000" stroke-width="8" stroke-miterlimit="10" points="2.7,11.21 12.7,20.38 30.87,2.88"></polyline>';
						html += '</svg>';
						html += '</span>';

						// Build the text span: show the full name only on the main label.
						html += '<span style="margin-left:10px; vertical-align:middle;">';
						html += '<strong>' + user.full_name + '</strong>';
						html += '</span>';

						// Build the tree view container which will include the email and locations.
						var treeHtml = '<ul style="list-style-type:none; padding:0; margin:0;">';
						// First list item: the email with a bottom border acting as a separator.
						treeHtml += '<li style="border-bottom: 1px solid #ccc; padding-bottom:5px; margin-bottom:5px;">' + user.email + '</li>';
						// Next, split the locations string into an array and list them.
						var locArray = user.locations.split(',');
						$.each(locArray, function (i, loc) {
							treeHtml += '<li>' + $.trim(loc) + '</li>';
						});
						treeHtml += '</ul>';

						// Add the locations container (initially hidden) containing the tree view.
						html += '<div class="locations-container" style="display:none; margin-left:40px; margin-top:5px;">' + treeHtml + '</div>';

						html += '</label>';
					});

					// Insert the generated HTML into the container.
					$('#response-forward__persons').html(html);
				},
				error: function (xhr, status, error) {
					console.error('AJAX call failed:', error);
				}
			});
		}
	}

	var initializeDataTable = function (table) {
		if ($.fn.DataTable.isDataTable(table)) {
			table.DataTable().destroy(); // ✅ Destroy previous instance
		}
		if (table.hasClass("with-chart"))
			return table.DataTable({
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: ["pageLength",
							{
								extend: 'collection',
								text: 'Download',
								attr: {
									class: "dt-button buttons-collection dt-download-btn",
								},
								buttons: [{
									extend: 'pdfHtml5',
									filename: function () {
										var locations = [];
										$('#checklistsList1-tree .tree-group').each(function () {
											var $chk = $(this).find('input.tree-group-check');
											if ($chk.is(':checked') || $chk.prop("indeterminate")) {
												locations.push($.trim($(this).find('.tree-group-label').text()));
											}
										});

										var firstLocation = locations.length > 0 ? locations[0] : "No Locations Selected";
										var locationName = locations.length > 1 ? `${firstLocation}-Et-al` : firstLocation;

										var dateRangeStr = $("#" + table.attr("include")).val();
										var dates = dateRangeStr.split(" - ");
										var startDate = formatDateStr(dates[0]);
										var endDate = formatDateStr(dates[1]);
										var dateRange = `${startDate} - ${endDate}`;

										return table.attr("report-title").includes("NFCs")
											? `${locationName}_Concerns-${dateRange}`
											: `${locationName}_Activity-${dateRange}`;

									},
									title: function () {
										return table.attr("report-title"); // Keep only the default report title
									},
									customize: function (doc) {
										const pageWidth = doc.pageSize.width;

										// ✅ Step 1: Remove Auto-Inserted Title to Prevent Duplication
										let titleIndex = doc.content.findIndex(item =>
											typeof item.text === "string" && item.text.includes(table.attr("report-title"))
										);

										if (titleIndex !== -1) {
											doc.content.splice(titleIndex, 1); // Remove only the first occurrence
										}

// ✅ Step 2: Keep Logo at the Top (centered)
												doc['header'] = function (currentPage) {
													if (currentPage === 1) {
														return {
															image: $("#logoBase64").attr("src"),
															width: 120,
															alignment: 'center',
															margin: [0, 20, 0, 0]
												};
											} else return null;
										};

										// ✅ Step 3: Insert Report Title Below the Logo
										doc.content.unshift({
											text: table.attr("report-title").includes("Completed") ? "Activity " + $("#" + table.attr("include")).val().replace(/\b(\d+)(st|nd|rd|th)\b/g, "$1") : "Concerns " + $("#" + table.attr("include")).val().replace(/\b(\d+)(st|nd|rd|th)\b/g, "$1"),
											fontSize: 16,
											bold: true,
													color: '#255047',
													alignment: 'center',
													margin: [0, 55, 0, 30] // Space between logo and title
												});

												// ✅ Theme table header
												doc.styles.tableHeader = {
													bold: true,
													fontSize: 11,
													color: '#ffffff',
													fillColor: '#255047',
													alignment: 'left'
												};

										// ✅ Step 4: Insert "Kera Insight" Heading
										doc.content.push({
											table: {
												widths: ['100%'],
												body: [
													[
														{
															text: "Kera Insight",
															fontWeight: 500,
															fontSize: 25,
															textTransform: "none",
															fontFamily: "Lato,arial,helvetica,sans-serif",
															bold: true,
															color: "#255047",
															alignment: "left",
															margin: [0, 10, 0, 5]
														}
													],
													[
														{
															text: "(Pure Data Analytics - Real Results)",
															fontWeight: 350,
															fontSize: 10,
															textTransform: "none",
															fontFamily: "Lato,arial,helvetica,sans-serif",
															italics: true,
															color: "#255047",
															alignment: "left",
															margin: [0, -10, 0, 10]
														}
													]
												]
											},
											layout: {
												hLineWidth: function () { return 0; },
												vLineWidth: function () { return 0; },
												paddingLeft: function () { return 2; },
												paddingRight: function () { return 2; },
												paddingTop: function () { return 2; },
												paddingBottom: function () { return 2; }
											},
											margin: [0, -20, 0, 20]
										});


										// ✅ Step 5: Insert Chart Below the Heading
										doc.content.push({
											alignment: 'center',
											image: $("#" + table.attr("id") + "-chartImg").attr("src"),
											width: 500, // Ensures proper scaling
											margin: [0, 0, 0, 40] // Space between heading and chart
										});

										// ✅ Step 6: Move Table Below the Chart
										let tableIndex = doc.content.findIndex(item => item.table);

										if (tableIndex !== -1) {
											let tableContent = doc.content[tableIndex];

											// ✅ Ensure new row has the same column count as the existing table
											let columnCount = tableContent.table.body[0].length;

											// ✅ Create a row with a single merged cell
											let mergedRow = [
												{
													text: "Click here for detailed Kera Insight",
													link: window.location.origin,
													color: "blue",
													fontSize: 20,
													decoration: "underline",
													alignment: "center",
													colSpan: columnCount, // Merges all columns
												}
											];

											// ✅ Fill remaining columns with empty objects (needed to maintain structure)
											for (let i = 1; i < columnCount; i++) {
												mergedRow.push({});
											}

											// ✅ Append the merged row at the end
											tableContent.table.body.push(mergedRow);
										}


										if (tableIndex !== -1) {
											let tableContent = doc.content.splice(tableIndex, 1)[0]; // Remove table from old position
											doc.content.push(tableContent); // Add table at the bottom
										}
									}
								}, 'excelHtml5', 'csvHtml5']
							}
						]
					}
				}
			});
		else
			return table.DataTable({
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: ["pageLength",
							{
								extend: 'collection',
								text: 'Download',
								buttons: ['excelHtml5', 'csvHtml5', 'pdfHtml5']
							}
						]
					}
				}
			});
	};

	var filterByJson = function (searchTerm, table, tableId) {
		searchTerm = String(searchTerm).toLowerCase();
		$.fn.dataTable.ext.search.push(
			function (settings, data, dataIndex) {
				if (settings.nTable.id !== tableId) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].toLowerCase().includes(searchTerm)) {
							return true;
						}
					}
				} else {
					try {
						var rowNode = settings.aoData[dataIndex].nTr;
						var questions = JSON.parse(JSON.parse($(rowNode).data('json'))).questions;
						var questionsStr = String(questions.map((u) => u.name).join(",")).toLowerCase();

						if (questionsStr.includes(searchTerm)) {
							return true;
						}

						for (var i = 0; i < data.length; i++) {
							if (data[i].toLowerCase().includes(searchTerm)) {
								return true;
							}
						}
					} catch (error) {
						for (var i = 0; i < data.length; i++) {
							if (data[i].toLowerCase().includes(searchTerm)) {
								return true;
							}
						}
					}
				}
			}
		);
		table.draw();
		$.fn.dataTable.ext.search.pop();
	}

	function populateTreeSelect() {
		const userIdElement = document.getElementById("userId");
		const userId = userIdElement ? userIdElement.value.trim() : null;
		const urlParams = new URLSearchParams(window.location.search);
		const locationId = urlParams.get("locationId");
		const domain = window.location.hostname;

		let url = "";

		if (!userId && locationId) {
			// 🟢 Case 1: userId missing, locationId present
			if (domain === "localhost") {
				url = `http://localhost:9101/public/ch-lo/tree-select/location?locationId=${locationId}`;
			} else {
				url = `/analyticservice/public/ch-lo/tree-select/location?locationId=${locationId}`;
			}
		}
		else if (userId) {
			// 🟢 Case 2: userId exists
			if (domain === "localhost") {
				url = `http://localhost:9101/public/ch-lo/tree-select?personId=${userId}`;
			} else {
				url = `/analyticservice/public/ch-lo/tree-select?personId=${userId}`;
			}
		}
		else {
			// 🟠 Case 3: Neither userId nor locationId found
			console.error("Both userId and locationId are missing. Cannot fetch data.");
			return;
		}

		// 🟢 Proceed to fetch data
		fetch(url)
			.then(response => {
				if (!response.ok) throw new Error("Network response was not ok");
				return response.json();
			})
			.then(data => {
				applyTreeSelectData(data);
			})
			.catch(error => {
				console.error("Fetch error:", error);
			});
	}

	// Re-render trees when a modal opens if the list is still empty (e.g. late DOM or failed first pass)
	$(document).on("click", "[data-toggle=imodal][data-target]", function () {
		const target = $(this).attr("data-target");
		if (!target || !window.__treeSelectData) return;
		setTimeout(function () {
			const modalId = target.replace("#", "");
			const treeMap = {
				checklistsModal: "#checklistsList1",
				reminderModal: "#checklistsList2",
				incidentModal: "#incidentsList",
				shiftModal: "#shiftsList"
			};
			const selectId = treeMap[modalId];
			if (!selectId) return;
			const $treeList = $(selectId + "-tree .tree-list");
			if ($treeList.length && $treeList.children().length === 0) {
				applyTreeSelectData(window.__treeSelectData);
			}
		}, 100);
	});


	// const selectAllCheckbox = document.getElementById('notif_sel_all_check_id');
	//     const rowCheckboxes = document.querySelectorAll('.checkbox_notif_class');

	//     selectAllCheckbox.addEventListener('change', function () {
	//         rowCheckboxes.forEach(function (checkbox) {
	//             checkbox.checked = selectAllCheckbox.checked;
	//         });
	//     });

	$(init);
})(jQuery);
